const leaflets = {
    "vivo": {
        "config": {
            "primary-color": "rgb(223, 5, 22)",
            "secondary-color": "rgb(45, 77, 157)",
            "tertiary-color": "rgb(99, 44, 56)",
            "hover-color": "rgba(220, 35, 17, 0.5)",
            "clientIcon": require("assets/images/Logo_vivo.png"),
            "serverPath": "vivo.volantinointerattivo.net/",
            "pdfPath": "/media/pdf/volantino.pdf",
            "shareFlyerTitle": "Dai uno sguardo al nuovo volantino di Vivo supermercati!",
            "shareFlyerURL": "https://vivo.volantinointerattivo.net?v=127",
            "shareProductSentence": "Guarda questa fantastica offerta!",
            "ogTitleMeta": "Volantino Interattivo Vivo supermercati",
            "ogDescriptionMeta": "Dai uno sguardo al nostro nuovo volantino. Offerte valide dal 15/09 al 26/09.",
            "ogImageMeta": "https://vivo.volantinointerattivo.net/media/images/vivo_fb_19.png",
            "filterBrand": 0,
            "filterUnderprice": 0,
            "brandImage": "",
            "underPriceImage": "",
            "ga_active": true,
            "ga_tracking_id": "UA-152069090-36",
            "release_id": "1",
            "send_grocery_list_to_market": false,
            "grocery_list_min_value": 20,
            "client_id": 28,
            "signboard_id": 45,
            "has_pages": true,
            "hide_grocery_list": false,
            "hide_searchbar": false,
            "line_through": false,
            "category_banner": "",
            "hide_plus_product": false,
            "hide_plus_product_price": false,
            "type": "leaflet"
        },
        "leaflet": {
            "name": "19 Vivo",
            "code": "127",
            "id_campaign": "127",
            "index": {
                "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/Indice_Vivo1_k2ap8DG.png",
                "links": [
                    {
                        "page": 2,
                        "blueprint": {
                            "top": 24.569185489866072,
                            "left": 12.878056355176717,
                            "width": 74.60781927253502,
                            "height": 5.83289103379811
                        }
                    },
                    {
                        "page": 4,
                        "blueprint": {
                            "top": 30.418679587673832,
                            "left": 13.117574313304747,
                            "width": 74.60781927253502,
                            "height": 5.83289103379811
                        }
                    },
                    {
                        "page": 6,
                        "blueprint": {
                            "top": 36.42041162748728,
                            "left": 13.13520297500242,
                            "width": 74.60781927253502,
                            "height": 5.83289103379811
                        }
                    },
                    {
                        "page": 8,
                        "blueprint": {
                            "top": 42.37200580812994,
                            "left": 13.142982041185801,
                            "width": 74.60781927253502,
                            "height": 5.83289103379811
                        }
                    },
                    {
                        "page": 10,
                        "blueprint": {
                            "top": 48.27017364184095,
                            "left": 12.854208814890086,
                            "width": 74.60781927253502,
                            "height": 5.83289103379811
                        }
                    },
                    {
                        "page": 13,
                        "blueprint": {
                            "top": 54.11967031280031,
                            "left": 13.169425033732308,
                            "width": 74.60781927253502,
                            "height": 5.83289103379811
                        }
                    },
                    {
                        "page": 14,
                        "blueprint": {
                            "top": 60.133480726283125,
                            "left": 12.724596595013663,
                            "width": 74.60781927253502,
                            "height": 5.83289103379811
                        }
                    },
                    {
                        "page": 16,
                        "blueprint": {
                            "top": 66.11288810270598,
                            "left": 12.994705894946252,
                            "width": 74.60781927253502,
                            "height": 5.83289103379811
                        }
                    },
                    {
                        "page": -1,
                        "type": "url",
                        "url": "https://volantinointerattivo.net",
                        "target": "_blank",
                        "blueprint": {
                            "top": 5.068637803590285,
                            "left": 58.78563885955649,
                            "width": 29.999999999999993,
                            "height": 7.343313249270139
                        }
                    }
                ]
            },
            "categories": [
                {
                    "category_name": "Igiene Casa",
                    "subcategories": [
                        "Bucato",
                        "Extra",
                        "Pavimenti",
                        "Superfici"
                    ]
                },
                {
                    "category_name": "Alimentari",
                    "subcategories": [
                        "Olio",
                        "Colazione",
                        "Dispensa",
                        "Snack Salati",
                        "Snack Dolci",
                        "Pasta",
                        "Rossi"
                    ]
                },
                {
                    "category_name": "Surgelati",
                    "subcategories": [
                        "Gelati",
                        "Ittico",
                        "Preparati",
                        "Verdure"
                    ]
                },
                {
                    "category_name": "No Food",
                    "subcategories": [
                        "Home",
                        "Esterno"
                    ]
                },
                {
                    "category_name": "Gastronomia",
                    "subcategories": [
                        "Formaggi",
                        "Salumi"
                    ]
                },
                {
                    "category_name": "Macelleria",
                    "subcategories": [
                        "Suino",
                        "Avicoli",
                        "Bovino"
                    ]
                },
                {
                    "category_name": "Self Service",
                    "subcategories": [
                        "Formaggi",
                        "Latte",
                        "Vegetali",
                        "Yogurt",
                        "Salumi"
                    ]
                },
                {
                    "category_name": "Ortofrutta",
                    "subcategories": [
                        "Frutta",
                        "Verdura"
                    ]
                },
                {
                    "category_name": "Bevande",
                    "subcategories": [
                        "Acqua",
                        "Birre",
                        "Bibite",
                        "Vini e Spumanti",
                        "Succhi"
                    ]
                },
                {
                    "category_name": "Igiene Persona",
                    "subcategories": [
                        "Corpo",
                        "Capelli",
                        "Orale",
                        "Viso"
                    ]
                }
            ],
            "pages": [
                {
                    "number": 1,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_1_3FlxCpt.jpg",
                    "products": [
                        {
                            "item_id": "206896",
                            "field1": "detersivo liquido lavatrice",
                            "field2": "dash",
                            "field3": "vari tipi",
                            "field4": "17 lavaggi",
                            "description": "detersivo liquido lavatrice dash vari tipi 17 lavaggi",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Lavanda",
                                "Actilift"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 35.167193981073055,
                                "left": 0.1401750548294108,
                                "width": 53.195420853142735,
                                "height": 32.02334790413002
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/principale_8001090797933_1570026998_1575628423_1582737271.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/principale_8001090797810_1570026998_1575628424_1582737271.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_olYYN6I_CJAS8gV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/video/Dash-consiglio.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "141264",
                            "field1": "olio extra vergine di oliva delizia",
                            "field2": "carapelli",
                            "field3": "cl. 75",
                            "field4": "",
                            "description": "olio extra vergine di oliva delizia carapelli cl. 75",
                            "grammage": 750,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Olio",
                            "blueprint": {
                                "top": 35.167193981073055,
                                "left": 53.33559590797214,
                                "width": 46.664404092027866,
                                "height": 32.02334790413002
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/0021958_CARAPELLI_DELIZIA_1524748459.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_SSs4qsQ_WJib9o8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Harissa",
                                    "data": {
                                        "ingredients": "250 g di peperoncino rosso piccante, 4 spicchi d'aglio, 3 cucchiai di coriandolo fresco in foglie, 1 cucchiaio di coriandolo secco in polvere, 1 cucchiaio di menta secca in foglie, 1 cucchiaio d'olio extravergine d'oliva Carapelli Delizia, 1 cucchiaio di sale",
                                        "recipe": "Priva i peperoncini dei semi e lasciali in ammollo in acqua per circa mezz'ora.\nSgocciolali, pestali con gli altri ingredienti oppure, se preferisci, passali nel mixer aggiungendo un po' di olio extravergine d'oliva per ottenere un composto molto denso.\nLa salsa si conserverà benissimo in un barattolo ermetico in frigorifero.\nRicorda però di proteggere la superficie con un velo d'olio ogni volta che prelevi la salsa dal barattolo.\n(fonte: carapelli.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mu5kxW23CP/images/harissa-600x390.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "138788",
                            "field1": "cornetto classico",
                            "field2": "algida",
                            "field3": "x 8 - gr. 480",
                            "field4": "",
                            "description": "cornetto classico algida x 8 - gr. 480",
                            "grammage": 480,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 67.0929777302733,
                                "left": 0.0,
                                "width": 49.83112407496665,
                                "height": 25.689374775531178
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Algida_CORNETTO_x8_CLASSICO_1582822894_1587979185_1588773471_1589475_d4WqrWv.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_dkM0TCH_fUSKbbA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/video/cornetto_algida.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "136278",
                            "field1": "croissant vuoti",
                            "field2": "bauli",
                            "field3": "gr. 200/240",
                            "field4": "vari gusti",
                            "description": "croissant vuoti bauli gr. 200/240 vari gusti",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 60.63104554857146,
                                "left": 50.16887592503335,
                                "width": 49.83112407496665,
                                "height": 32.08732743068153
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Croissant_Classico_6pz_H_1580401972_1581352333_1582560088_1591181892_OV0qA0z.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_YpniOGg_4wcMUkW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "world",
                                    "title": "",
                                    "data": "https://www.bauli.it/it"
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 2,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_2_DxkBNgm.jpg",
                    "products": [
                        {
                            "item_id": "231654",
                            "field1": "maxiquaderni",
                            "field2": "mitama",
                            "field3": "elementari/medie/superiori",
                            "field4": "varie rigature",
                            "description": "maxiquaderni mitama elementari/medie/superiori varie rigature",
                            "grammage": 0,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 0.0,
                                "left": 62.44068564725955,
                                "width": 37.55931435274046,
                                "height": 31.030070377479205
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/62300-1-2-3-4-5-6-7_1598957247.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_WBamqPD_hRK4FiG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138765",
                            "field1": "penna sfera cristal",
                            "field2": "bic",
                            "field3": "pz. 10",
                            "field4": "blu/nera",
                            "description": "penna sfera cristal bic pz. 10 blu/nera",
                            "grammage": 0,
                            "price": "2.69",
                            "price_label": "€ 2,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Blu",
                                "Nera"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 23.928342930262318,
                                "left": 0.0,
                                "width": 37.55931435274046,
                                "height": 31.030070377479205
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/BIC_10_PENNE_BLU_1501851284.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/BIC-10-penna-a-sfera-Cristal-original-Nero-_1599212641.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_LOQ2RN8_D1AM38M.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138764",
                            "field1": "penna cancellabile replay",
                            "field2": "paper mate",
                            "field3": "pz. 2",
                            "field4": "blu/nera/rossa",
                            "description": "penna cancellabile replay paper mate pz. 2 blu/nera/rossa",
                            "grammage": 0,
                            "price": "2.39",
                            "price_label": "€ 2,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Blu",
                                "Nera",
                                "Rossa"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 23.928342930262318,
                                "left": 37.55931435274046,
                                "width": 29.937060140754955,
                                "height": 31.030070377479205
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/30832_1598969103.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/30834_1598969104.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/paper_mate_rossa_1599212682.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_EwTEu1l_60Ng9uZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231657",
                            "field1": " pritt",
                            "field2": "correttore pocket pen",
                            "field3": "pz. 2",
                            "field4": "",
                            "description": " pritt correttore pocket pen pz. 2",
                            "grammage": 0,
                            "price": "2.50",
                            "price_label": "€ 2,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 33.20537428023032,
                                "left": 67.49637449349542,
                                "width": 32.503625506504584,
                                "height": 21.7530390275112
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/1758025---pocket-pen-blister-2pz4_1598953152.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_i1yOEuc_DtSHc8r.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138757",
                            "field1": "bloc notes",
                            "field2": "mitama",
                            "field3": "60 fogli",
                            "field4": "cm. 8x12 - pz. 4",
                            "description": "bloc notes mitama 60 fogli cm. 8x12 - pz. 4",
                            "grammage": 0,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 54.958413307741516,
                                "left": 69.30592876946044,
                                "width": 30.694071230539564,
                                "height": 22.13691618682022
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/MitamaBlocNotes_1535355495.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_MLi1ZYM_osSikQH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138756",
                            "field1": "bloc notes",
                            "field2": "mitama",
                            "field3": "60 fogli",
                            "field4": "cm. 21x29,7 - pz. 2",
                            "description": "bloc notes mitama 60 fogli cm. 21x29,7 - pz. 2",
                            "grammage": 0,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 54.958413307741516,
                                "left": 34.04174664107485,
                                "width": 35.264182128385585,
                                "height": 22.13691618682022
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/MitamaBlocNotes_1535355480.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_EJidK8y_yPlokwF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138755",
                            "field1": "bloc notes",
                            "field2": "mitama",
                            "field3": "60 fogli",
                            "field4": "cm. 10x15 - pz. 4/cm. 15x21 - pz. 2",
                            "description": "bloc notes mitama 60 fogli cm. 10x15 - pz. 4/cm. 15x21 - pz. 2",
                            "grammage": 0,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "10x15 pz.4",
                                "15x21 pz.2"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 54.958413307741516,
                                "left": 5.700095969289828,
                                "width": 28.341650671785033,
                                "height": 22.13691618682022
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/MitamaBlocNotes_1535355464.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_VrB6lgq_N0c7KUS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231653",
                            "field1": "cartella 3 lembi ",
                            "field2": "mitama",
                            "field3": "color touch cm. 26x35 ",
                            "field4": "colori assortiti",
                            "description": "cartella 3 lembi  mitama color touch cm. 26x35  colori assortiti",
                            "grammage": 0,
                            "price": "1.20",
                            "price_label": "€ 1,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Rosso",
                                "Blu",
                                "Verde"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Esterno",
                            "blueprint": {
                                "top": 77.09532949456175,
                                "left": 5.700095969289828,
                                "width": 30.422638089144808,
                                "height": 21.241202815099168
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/62030_1598969640.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_9b7PoBr_Hdss1Xs.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231655",
                            "field1": " pritt",
                            "field2": "colla stick",
                            "field3": "gr. 22x2 + gr. 10",
                            "field4": "",
                            "description": " pritt colla stick gr. 22x2 + gr. 10",
                            "grammage": 54,
                            "price": "3.50",
                            "price_label": "€ 3,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Esterno",
                            "blueprint": {
                                "top": 77.09532949456175,
                                "left": 36.12273405843464,
                                "width": 27.845009596928982,
                                "height": 21.241202815099168
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/1445001---pritt-colla-stick-22g-2pz_1598953132.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_y4CmbNE_540RbmW.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "title": "Applicazioni",
                                    "data": {
                                        "specifiche": "Carta, Cartoncino, Stoffa, Feltro, Foto, Cotone",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mu5kxW23CP/images/packshot-front-it-pritt-original-43g.jpeg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "231656",
                            "field1": " ",
                            "field2": "pritt",
                            "field3": "colla vinil",
                            "field4": "gr. 100",
                            "description": "  pritt colla vinil gr. 100",
                            "grammage": 100,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Esterno",
                            "blueprint": {
                                "top": 77.09532949456175,
                                "left": 63.96774365536362,
                                "width": 36.03225634463638,
                                "height": 21.241202815099168
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/1869964-pritt-vinil-100g-300dpi-_1598953142.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_hcWMAwR_ipfoeWp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 3,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_3_bDVBodt.jpg",
                    "products": [
                        {
                            "item_id": "138754",
                            "field1": "album disegno f2",
                            "field2": "fabriano",
                            "field3": "cm. 24 x 33",
                            "field4": "ruvido/liscio",
                            "description": "album disegno f2 fabriano cm. 24 x 33 ruvido/liscio",
                            "grammage": null,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Ruvido",
                                "Liscio"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 1.727447216890595,
                                "left": 0.0,
                                "width": 60.450175943698014,
                                "height": 30.326295585412666
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/1_1598957210.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/2_1598957210.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_ACHlrkJ_uxQnWVI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "",
                                    "data": {
                                        "titolo": "Fabriano Disegno 2",
                                        "testo": "Album, blocchi o fogli per la scuola. Carta prodotta con il 100% di cellulosa E.C.F. (Elemental Chlorine Free), certificata F.S.C. (©1996 Forest Stewardship Council A.C.) proveniente da foreste gestite secondo rigorosi standard ambientali, sociali ed economici. Due superfici disponibili: RUVIDA e LISCIA.\nRUVIDA: per grafite morbida, carboncino, pastello. LISCIA: per matita, pastello, cera, pennarello, china. La filigrana riproduce il marchio ed il logotipo FABRIANO ed il numero 2.\n(fonte: fabriano.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mu5kxW23CP/images/569.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "138760",
                            "field1": "matita noris ",
                            "field2": "staedtler",
                            "field3": "pz. 2",
                            "field4": "b/hb",
                            "description": "matita noris  staedtler pz. 2 b/hb",
                            "grammage": 0,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "b",
                                "hb"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 32.05374280230326,
                                "left": 0.0,
                                "width": 40.635556621881,
                                "height": 23.352527191298787
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/1056482_1503308947.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/31904_1535355722.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_AeVdtdg_oYXEuNO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138768",
                            "field1": "temperini alluminio colorati",
                            "field2": "joywork",
                            "field3": "pz. 2",
                            "field4": "",
                            "description": "temperini alluminio colorati joywork pz. 2",
                            "grammage": 0,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 32.05374280230326,
                                "left": 40.635556621881,
                                "width": 28.94180528897419,
                                "height": 23.352527191298787
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/61280_1598968852.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_P8ShRHQ_hnhjv4w.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138759",
                            "field1": "gomma per matita e inchiostro",
                            "field2": "reset",
                            "field3": "pz. 2",
                            "field4": "",
                            "description": "gomma per matita e inchiostro reset pz. 2",
                            "grammage": 0,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 32.05374280230326,
                                "left": 69.57736191085519,
                                "width": 30.422638089144808,
                                "height": 23.352527191298787
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/61299_1598968799.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_so2Rar4_LEw96Xt.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138769",
                            "field1": "pennarelli turbo color",
                            "field2": "fila giotto",
                            "field3": "pz. 12",
                            "field4": "",
                            "description": "pennarelli turbo color fila giotto pz. 12",
                            "grammage": 0,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 55.40626999360205,
                                "left": 69.57736191085519,
                                "width": 30.422638089144808,
                                "height": 21.113243761996163
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/18494_1598969157.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_o6vis5Q_GxMJGv7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138762",
                            "field1": "pastello cera tondo",
                            "field2": "fila giotto",
                            "field3": "pz. 12",
                            "field4": "",
                            "description": "pastello cera tondo fila giotto pz. 12",
                            "grammage": 0,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 55.40626999360205,
                                "left": 39.01802089997867,
                                "width": 30.55934101087652,
                                "height": 21.113243761996163
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/30632_1598969069.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_UGrYJMs_drv5pOT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138763",
                            "field1": "pastello stilnovo laccato ",
                            "field2": "fila giotto",
                            "field3": "pz. 12",
                            "field4": "",
                            "description": "pastello stilnovo laccato  fila giotto pz. 12",
                            "grammage": 0,
                            "price": "3.89",
                            "price_label": "€ 3,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 55.40626999360205,
                                "left": 0.0,
                                "width": 39.01802089997867,
                                "height": 21.113243761996163
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/GiottoStilnovoLaccato_1535355629.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_VWHhXuZ_qlDrefp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138767",
                            "field1": "tempera tubo colori primari",
                            "field2": "fila giotto",
                            "field3": "ml. 21x5 ",
                            "field4": "",
                            "description": "tempera tubo colori primari fila giotto ml. 21x5 ",
                            "grammage": 0,
                            "price": "4.50",
                            "price_label": "€ 4,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 76.5195137555982,
                                "left": 0.0,
                                "width": 56.20878652164641,
                                "height": 23.480486244401792
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/18500_1598969139.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_e6iibFk_pQNGLa7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138753",
                            "field1": "acquerelli",
                            "field2": "fila giotto",
                            "field3": "pz. 12",
                            "field4": "",
                            "description": "acquerelli fila giotto pz. 12",
                            "grammage": 0,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 76.5195137555982,
                                "left": 56.20878652164641,
                                "width": 43.7912134783536,
                                "height": 23.480486244401792
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/39430_1598958168.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_Zrb5zA2_8P4Ld1w.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 4,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_4_Gf5cvy9.jpg",
                    "products": [
                        {
                            "item_id": "130862",
                            "field1": "formaggio",
                            "field2": "brigante",
                            "field3": "al kg",
                            "field4": "",
                            "description": "formaggio brigante al kg",
                            "grammage": 0,
                            "price": "9.99",
                            "price_label": "€ 9,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 7.549584133077416,
                                "left": 0.0,
                                "width": 44.61657602900405,
                                "height": 26.871401151631474
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/brigante_1481123729_1530517571.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_UODlE7A_N6B4wb5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "137526",
                            "field1": " grana padano ",
                            "field2": "scelto ",
                            "field3": "al kg",
                            "field4": "",
                            "description": " grana padano  scelto  al kg",
                            "grammage": null,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 7.549584133077416,
                                "left": 44.61657602900405,
                                "width": 55.38342397099595,
                                "height": 26.871401151631474
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/grana_padano_spicchio_logo_1559921759.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_DBPLVMb_fKdP51y.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Spiedini di bocconcini di Grana Padano DOP su crema di broccoli",
                                    "data": {
                                        "ingredients": "Grana Padano DOP, 1 spicchio di aglio, 2 Uova, 400 g di broccoli, 4 cucchiai di pangrattato, Olio extravergine d'oliva, sale, olio",
                                        "recipe": "Tagliare i cubetti di Grana Padano Dop e ricavarne 16 bocconcini, lavare accuratamente il broccolo e poi tagliarlo a pezzettini e farlo saltare in padella con uno spicchio di aglio in camicia, un cucchiaio di olio extravergine di oliva e una spolverata di sale e pepe. Cuocere il broccolo in padella per circa 15 minuti, se necessario aggiungere mezzo bicchiere di acqua per evitare che si secchi troppo e a fine cottura poi frullarlo con un frullatore a immersione ricavandone una crema. Sbattere le uova in una ciotola e passare i bocconcini di Grana Padano Dop prima nell’uovo e poi nel pangrattato. Una volta impanato il formaggio, friggerlo in abbondante olio per pochi minuti. Preparare l’aperitivo servendo i bocconcini di formaggio infilzati con degli spiedini di bambù e adagiati sulla crema di broccolo.\n(fonte: buonissimo.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mu5kxW23CP/images/resize_spiedini.webp"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "132122",
                            "field1": "treccione affumicato",
                            "field2": "zappalà",
                            "field3": "al kg",
                            "field4": "",
                            "description": "treccione affumicato zappalà al kg",
                            "grammage": 0,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 34.4209852847089,
                                "left": 0.0,
                                "width": 33.84972808701216,
                                "height": 21.369161868202177
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/zappala_treccione_affumicato_1531757282_1561449569.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_ZTGOyrw_x8gZCuR.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "175977",
                            "field1": "formaggio svizzero original",
                            "field2": "emmentaler",
                            "field3": "al kg",
                            "field4": "",
                            "description": "formaggio svizzero original emmentaler al kg",
                            "grammage": 0,
                            "price": "14.90",
                            "price_label": "€ 14,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 34.4209852847089,
                                "left": 33.84972808701216,
                                "width": 66.15027191298785,
                                "height": 21.369161868202177
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/2353_emmentaler_svizzero_1429018312_1470129375_1483345558_1553532675.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/FETTA_EMMENTHAL_1562233505.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_2FwJyUS_TbQp9Tf.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129592",
                            "field1": "petto di tacchino",
                            "field2": "aia tarky",
                            "field3": "al kg",
                            "field4": "",
                            "description": "petto di tacchino aia tarky al kg",
                            "grammage": null,
                            "price": "8.90",
                            "price_label": "€ 8,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 55.79014715291106,
                                "left": 66.15027191298785,
                                "width": 33.84972808701216,
                                "height": 21.177223288547665
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/1468_aia_aequilibrium_tarky_tacchino_forno_1471612738_1529332718.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/fesa_prosciutto_cotto_arrosto_shutter_1471612732_1529332719.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_36b5SmW_d7k8EQr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129591",
                            "field1": "mortadella suprema",
                            "field2": "fiorucci",
                            "field3": "al kg",
                            "field4": "",
                            "description": "mortadella suprema fiorucci al kg",
                            "grammage": null,
                            "price": "7.90",
                            "price_label": "€ 7,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 55.79014715291106,
                                "left": 33.86079121347836,
                                "width": 32.28948069950949,
                                "height": 21.177223288547665
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Fiorucci_Suprema_Su_Tagliere_1524062740_1529332333.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/mortadella_piatto_1429717241_1529332334.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_ExQxAaQ_JebHf8m.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129622",
                            "field1": "pecorino fresco",
                            "field2": "dedoni",
                            "field3": "al kg",
                            "field4": "",
                            "description": "pecorino fresco dedoni al kg",
                            "grammage": 0,
                            "price": "10.90",
                            "price_label": "€ 10,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 55.79014715291106,
                                "left": 0.0,
                                "width": 33.86079121347836,
                                "height": 21.177223288547665
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/pecorino__generico_1521195855_1529336616_1529337371_1529340191_1564562802.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_6u6AFO8_43XRYRh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "132160",
                            "field1": "prosciutto cotto primastella",
                            "field2": "negroni\t",
                            "field3": "al kg",
                            "field4": "",
                            "description": "prosciutto cotto primastella negroni\t al kg",
                            "grammage": 0,
                            "price": "14.90",
                            "price_label": "€ 14,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 76.96737044145874,
                                "left": 0.0,
                                "width": 33.86079121347836,
                                "height": 21.241202815099168
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/2623_Negroni_prosciutto_cotto_primastella.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/prosciutto_cotto_ambientato_1531900256.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_Ua5hSVG_Vfs8RKY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "142570",
                            "field1": "speck di montagna",
                            "field2": "senfter",
                            "field3": "al kg",
                            "field4": "",
                            "description": "speck di montagna senfter al kg",
                            "grammage": null,
                            "price": "10.90",
                            "price_label": "€ 10,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 76.96737044145874,
                                "left": 33.86079121347836,
                                "width": 32.18793985924504,
                                "height": 21.241202815099168
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Speck_tagliere_ambientato_ok_1524555269_1527243736_1532965477.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_47ED4RF_sZv5Vgp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "",
                                    "data": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/video/Speck_Senfter.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "130859",
                            "field1": "spianata",
                            "field2": "san vincenzo",
                            "field3": "al kg",
                            "field4": "dolce/piccante",
                            "description": "spianata san vincenzo al kg dolce/piccante",
                            "grammage": 0,
                            "price": "13.90",
                            "price_label": "€ 13,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [
                                "Dolce",
                                "Piccante"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Gastronomia",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 76.96737044145874,
                                "left": 66.0487310727234,
                                "width": 33.95126892727661,
                                "height": 21.241202815099168
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/san_vincenzo_Spianata_dolce_1549536514.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/san_vincenzo_Spianata_piccante_1549536515.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_PfFhZ6T_CX51Da8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 5,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_5_7DwUjzo.jpg",
                    "products": [
                        {
                            "item_id": "137580",
                            "field1": "tritato ",
                            "field2": "di suino",
                            "field3": "al kg",
                            "field4": "",
                            "description": "tritato  di suino al kg",
                            "grammage": 0,
                            "price": "4.99",
                            "price_label": "€ 4,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 7.869481765834933,
                                "left": 32.39102153977394,
                                "width": 33.95126892727661,
                                "height": 18.746001279590534
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Macinato_maiale_1452766467_1533032672.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_02OAbTJ_dGnPu6z.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130845",
                            "field1": "salsiccia ",
                            "field2": "di suino",
                            "field3": "dolce/piccante ",
                            "field4": "al kg",
                            "description": "salsiccia  di suino dolce/piccante  al kg",
                            "grammage": 0,
                            "price": "4.99",
                            "price_label": "€ 4,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [
                                "Dolce",
                                "Piccante"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 7.421625079974408,
                                "left": 59.26290253785454,
                                "width": 40.73709746214545,
                                "height": 21.497120921305186
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Salsiccia_di_maiale_1491812086_1495725905_1512380581_1549559390.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_AcNjLfo_NXZcYeG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129923",
                            "field1": "polpa ",
                            "field2": "di suino",
                            "field3": "al kg",
                            "field4": "",
                            "description": "polpa  di suino al kg",
                            "grammage": 0,
                            "price": "4.99",
                            "price_label": "€ 4,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 26.167626359564938,
                                "left": 30.49098955001066,
                                "width": 34.1322243548731,
                                "height": 18.04222648752399
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Polpa_di_Suino_al_Kg_1529507533_1547199954_1562669646.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_3ZkOADO_xmUabFg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129669",
                            "field1": "capocollo con osso ",
                            "field2": "di suino",
                            "field3": "a fette ",
                            "field4": "al kg",
                            "description": "capocollo con osso  di suino a fette  al kg",
                            "grammage": 0,
                            "price": "4.99",
                            "price_label": "€ 4,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 28.726807421625082,
                                "left": 58.72003625506505,
                                "width": 41.27996374493496,
                                "height": 18.04222648752399
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/capocollo_1558951831.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_dcRmtG8_VSQR1LC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "132191",
                            "field1": "bistecca di lombo  ",
                            "field2": "con osso",
                            "field3": "di suino",
                            "field4": "al kg",
                            "description": "bistecca di lombo   con osso di suino al kg",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 41.71465131158029,
                                "left": 0.0,
                                "width": 41.27996374493496,
                                "height": 24.952015355086374
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/lombo_suino_1463763971_1549559598.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_m7Ok9Np_iMUGK6k.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "title": "COME CUCINARE LE BISTECCHE DI MAIALE",
                                    "data": {
                                        "titolo": "COME CUCINARE LE BISTECCHE DI MAIALE",
                                        "testo": "Ci sono modi diversi di cucinare le bistecche di maiale, o braciole: potete portarle in tavola semplicemente cotte in padella con un filo d’olio extravergine d'oliva e insaporite da erbe aromatiche o spezie; potete cuocerle con o senza osso, potete farcirle o cucinarle al forno con una croccante panatura.\n\nTagliate più spesse, possono diventare l’involucro per un ripieno gustoso, fatto di formaggi o verdure e, in questo caso, potete utilizzare sia le bistecche con l’osso, sia quelle senza.\n\nLa cottura sulla piastra o sulla brace di queste protagoniste indiscusse del barbecue, insieme alla salsiccia, richiederà sicuramente una marinatura che servirà a insaporire la carne e a farla diventare più tenera in cottura.\n\nCon le bistecche di maiale potete preparare secondi piatti stuzzicanti o anche antipasti appetitosi se, affettata finemente la lonza, arrotolate la carne con un gustoso ripieno.\n\nPer ottenere un buon risultato, la cosa importante è fare attenzione alla cottura: la carne di maiale, al contrario della carne rossa, deve essere sempre ben cotta, per esaltarne al massimo il sapore; se non si fa attenzione però si rischia di farla diventare troppo dura.\n(fonte: galbani.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mu5kxW23CP/images/lombo_suino_1463763971_1549559598.jpg"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "177982",
                            "field1": "coscia a fette",
                            "field2": "di suino",
                            "field3": "al kg",
                            "field4": "",
                            "description": "coscia a fette di suino al kg",
                            "grammage": null,
                            "price": "4.99",
                            "price_label": "€ 4,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 43.5060780550224,
                                "left": 27.86713584986138,
                                "width": 41.27996374493496,
                                "height": 23.41650671785029
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/prosciutto_suino_fettine_sigma_1451902236_1556008283_1556288906.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_QxfILrU_md5al9w.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "hat-chef",
                                    "title": "Fettine alla genovese",
                                    "data": {
                                        "ingredients": "Fettine di vitello 400 g,  Olio di oliva extravergine 3 cucchiai, Burro 40 g, Aglio 1 spicchio, Alloro secco 1 foglia, Sale q.b.,  Limone 1/2",
                                        "recipe": "In un tegame unire burro, olio, aglio e la foglia di alloro e scaldare il tutto. Appena l'aglio apparirà dorato unire le fettine di carne, lasciandole cuocere a fiamma alta per non più di un minuto per lato. \nTogliere le fettine di carne sistemandole in un piatto da portata riscaldato e lasciar soffriggere ancora il sugo di cottura abbassando la fiamma. Eliminare l'aglio e la foglia d'alloro dal sugo, aggiungere il succo del mezzo limone, mescolare e versare sulle fette di carne, servendo subito in tavola.\n(fonte: buonissimo.it)",
                                        "img": [
                                            "https://interattivo.s3.amazonaws.com/mu5kxW23CP/images/fettine-alla-genovese.webp"
                                        ]
                                    }
                                }
                            ]
                        },
                        {
                            "item_id": "175051",
                            "field1": "pancetta con costine",
                            "field2": "di suino",
                            "field3": "al kg",
                            "field4": "",
                            "description": "pancetta con costine di suino al kg",
                            "grammage": 0,
                            "price": "4.99",
                            "price_label": "€ 4,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Suino",
                            "blueprint": {
                                "top": 46.89699296225208,
                                "left": 66.6137236084453,
                                "width": 33.3862763915547,
                                "height": 20.0255918106206
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/pancetta_fette_1553614918_1583833587.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_iW5U21Y_8HGT6G8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130847",
                            "field1": "cosce ",
                            "field2": "di pollo",
                            "field3": "al kg",
                            "field4": "",
                            "description": "cosce  di pollo al kg",
                            "grammage": 0,
                            "price": "3.89",
                            "price_label": "€ 3,89 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 66.92258477287267,
                                "left": 66.6137236084453,
                                "width": 33.3862763915547,
                                "height": 15.61100447856686
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/sovracosce_pollo_tagliere_shutter_1457450525_1461940996_1515061039_1_awfCNLv.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_1UlhSxn_81g4RhN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "132172",
                            "field1": "fettine sceltissime ",
                            "field2": "di bovino adulto ",
                            "field3": "noce/fesa",
                            "field4": "al kg",
                            "description": "fettine sceltissime  di bovino adulto  noce/fesa al kg",
                            "grammage": 0,
                            "price": "9.90",
                            "price_label": "€ 9,90 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [
                                "Noce",
                                "Fesa"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 66.92258477287267,
                                "left": 33.77031349968011,
                                "width": 32.8434101087652,
                                "height": 15.61100447856686
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/noce_1528450090_2_1545044168_1556288877.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_yoIsMgd_Ub0S206.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "142436",
                            "field1": "bocconcini",
                            "field2": "di bovino adulto",
                            "field3": "al kg",
                            "field4": "",
                            "description": "bocconcini di bovino adulto al kg",
                            "grammage": 0,
                            "price": "7.50",
                            "price_label": "€ 7,50 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Bovino",
                            "blueprint": {
                                "top": 66.92258477287267,
                                "left": 0.0,
                                "width": 33.77031349968011,
                                "height": 15.61100447856686
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/bocconcini_angus_1453456050.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_sUA2lNj_5uV49ax.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "142437",
                            "field1": "cotoletta valdostana con scamorza affumicata",
                            "field2": "aia",
                            "field3": "gr. 200",
                            "field4": "",
                            "description": "cotoletta valdostana con scamorza affumicata aia gr. 200",
                            "grammage": 200,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 82.53358925143954,
                                "left": 0.0,
                                "width": 33.77031349968011,
                                "height": 15.80294305822137
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Aia_Valdostana_1541612538_1546421927_1546525791_1547476640_157962762_y4I39kf.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_CPdlwFE_pYRC5pq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129668",
                            "field1": "spinacine",
                            "field2": "aia",
                            "field3": "gr. 220",
                            "field4": "",
                            "description": "spinacine aia gr. 220",
                            "grammage": 220,
                            "price": "1.20",
                            "price_label": "€ 1,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 82.53358925143954,
                                "left": 33.77031349968011,
                                "width": 32.73080614203455,
                                "height": 15.80294305822137
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Aia_spinacine_x2_1541612518_2_1583311077_1589902253.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_grIHGxe_IV7DHOv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "137578",
                            "field1": "cotoletta di pollo",
                            "field2": "gusto ricco",
                            "field3": "gr. 1000",
                            "field4": "classica/spinaci",
                            "description": "cotoletta di pollo gusto ricco gr. 1000 classica/spinaci",
                            "grammage": 0,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classica",
                                "Spinaci"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Macelleria",
                            "subcategory": "Avicoli",
                            "blueprint": {
                                "top": 82.53358925143954,
                                "left": 66.50111964171465,
                                "width": 33.49888035828535,
                                "height": 15.80294305822137
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Cotoletta_spinaci_Gustoricco_1_1455007240_1552487654.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_HBZ548G_3XBFJEx.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 6,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_6_y8DVNZT.jpg",
                    "products": [
                        {
                            "item_id": "173977",
                            "field1": "galbanino",
                            "field2": "galbani",
                            "field3": "gr. 550",
                            "field4": "",
                            "description": "galbanino galbani gr. 550",
                            "grammage": 550,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 15.56894618834081,
                                "left": 0.2505044843049279,
                                "width": 62.34937173019433,
                                "height": 18.723024103139018
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Galbani_Galbanino_550g_1543428018_1545414101_1545931291_1560522950.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_ZhDojEL_HD7bjpQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "Galbanino - VideoRicetta",
                                    "data": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/video/Galbanino-Videoricetta.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "130833",
                            "field1": "parmigiano reggiano grattugiato dop",
                            "field2": "parmareggio",
                            "field3": "gr. 60",
                            "field4": "",
                            "description": "parmigiano reggiano grattugiato dop parmareggio gr. 60",
                            "grammage": 60,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 8.12640134529148,
                                "left": 54.53353098140882,
                                "width": 45.46646901859119,
                                "height": 25.204246076233186
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/33586_Parmareggio60gr_1575281106_1575307078_1575382534_1576488912.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_z2Y3WyI_GXfaIS4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130826",
                            "field1": "bocconcino",
                            "field2": "zappalà",
                            "field3": "gr. 100 x 3",
                            "field4": "",
                            "description": "bocconcino zappalà gr. 100 x 3",
                            "grammage": 300,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 34.33856502242153,
                                "left": 0.0,
                                "width": 33.19853355054186,
                                "height": 16.82875560538117
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/zappala_mozzarella_100x3_1530528857.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_ETaxykO_zlcpELV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129597",
                            "field1": "burro",
                            "field2": "parmareggio",
                            "field3": "gr. 100",
                            "field4": "",
                            "description": "burro parmareggio gr. 100",
                            "grammage": 100,
                            "price": "0.75",
                            "price_label": "€ 0,75",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 34.373248318385656,
                                "left": 33.520070184043355,
                                "width": 33.19853355054186,
                                "height": 16.82875560538117
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/447025_parmareggio_BURRO_200g_1563528313_1570025289.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_tKHieIT_Jln6tyw.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "137585",
                            "field1": "mascarpone",
                            "field2": "polenghi",
                            "field3": "gr. 500",
                            "field4": "",
                            "description": "mascarpone polenghi gr. 500",
                            "grammage": 500,
                            "price": "2.90",
                            "price_label": "€ 2,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 34.47764854260091,
                                "left": 66.53740015414799,
                                "width": 33.19853355054186,
                                "height": 16.82875560538117
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/polenghi_macarpone_1533651446.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_RApnCDo_30KS7lF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129603",
                            "field1": "mozzarella",
                            "field2": "calabrialatte",
                            "field3": "gr. 100",
                            "field4": "",
                            "description": "mozzarella calabrialatte gr. 100",
                            "grammage": 100,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 51.2314321748879,
                                "left": 0.43499100803437973,
                                "width": 33.19853355054186,
                                "height": 15.493273542600898
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/MOZZARELLA_CALABRIALATTE_GR.100_1529334412.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_Zbi2tE6_vVs29ze.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "131064",
                            "field1": "ricotta",
                            "field2": "calabria latte",
                            "field3": "gr. 250",
                            "field4": "",
                            "description": "ricotta calabria latte gr. 250",
                            "grammage": 250,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 51.729610426008975,
                                "left": 33.00234170637145,
                                "width": 33.19853355054186,
                                "height": 15.493273542600898
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/secondaria_8024707300012_1530545183.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_WovB1SE_KyhXQJF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "218987",
                            "field1": "cubetti",
                            "field2": "biraghi",
                            "field3": "",
                            "field4": "gr. 250",
                            "description": "cubetti biraghi gr. 250",
                            "grammage": 250,
                            "price": "2.90",
                            "price_label": "€ 2,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 50.95466647982063,
                                "left": 66.80146644945816,
                                "width": 33.19853355054186,
                                "height": 15.493273542600898
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Biraghi_biraghini_250_g_1429193207_1430212693_1522766320_1558109896__6XYnz7V.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_tESwXQU_8Nu7YIj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "185834",
                            "field1": "petali sottili",
                            "field2": "biraghi",
                            "field3": "gr. 80",
                            "field4": "",
                            "description": "petali sottili biraghi gr. 80",
                            "grammage": 80,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 68.02305213004485,
                                "left": 1.0645024640321328,
                                "width": 31.020605906670408,
                                "height": 14.554021860986548
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Petali-Sottili-80g_1543317434_1564147955.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_nWcuWo1_OCwNyeY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "205505",
                            "field1": "pesto classico",
                            "field2": "biffi",
                            "field3": "vari tipi",
                            "field4": "gr. 90",
                            "description": "pesto classico biffi vari tipi gr. 90",
                            "grammage": 90,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "classico",
                                "senza aglio"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Vegetali",
                            "blueprint": {
                                "top": 67.32202914798206,
                                "left": 34.155031413490285,
                                "width": 31.020605906670408,
                                "height": 30.556684417040362
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/secondaria_80073291_1581084108.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/secondaria_80073307_1599031375.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_IPx3gkV_QbPxHxi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129610",
                            "field1": "formaggini",
                            "field2": "susanna",
                            "field3": "gr. 140",
                            "field4": "",
                            "description": "formaggini susanna gr. 140",
                            "grammage": 140,
                            "price": "1.10",
                            "price_label": "€ 1,10",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 67.25966928251121,
                                "left": 66.96365844544096,
                                "width": 31.020605906670408,
                                "height": 15.0210201793722
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Sottilette_Susanna_8_formaggini_140_g_1529335441.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_YDzAlDJ_tm19KOA.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "163429",
                            "field1": "sottilette",
                            "field2": "light",
                            "field3": "gr. 200",
                            "field4": "",
                            "description": "sottilette light gr. 200",
                            "grammage": 200,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 83.02550448430495,
                                "left": 67.54214020459644,
                                "width": 31.020605906670408,
                                "height": 15.0210201793722
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/445679_1566487506_1568208774_1569830862_1570198559_1571665005.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_KB1pPw7_qDnWTnP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 7,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_7_uVPQNom.jpg",
                    "products": [
                        {
                            "item_id": "205504",
                            "field1": "base pinsa",
                            "field2": "pinsami",
                            "field3": "pz. 2 - gr. 460",
                            "field4": "",
                            "description": "base pinsa pinsami pz. 2 - gr. 460",
                            "grammage": 460,
                            "price": "3.69",
                            "price_label": "€ 3,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 7.055423206278029,
                                "left": 0.0,
                                "width": 45.688918862107634,
                                "height": 26.859585201793728
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/pinsa_1581334410.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_vthONu4_GXVaBVP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130835",
                            "field1": "yogurt",
                            "field2": "parmalat",
                            "field3": "gr. 125 x 2",
                            "field4": "intero/magro vari gusti",
                            "description": "yogurt parmalat gr. 125 x 2 intero/magro vari gusti",
                            "grammage": 250,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "intero",
                                "magro"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 7.845081278026908,
                                "left": 47.33388482109492,
                                "width": 50.892461638172655,
                                "height": 26.859585201793728
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Fragola_1468851532_1530516251_1530517394.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/parmalat_magro_01_grassi_ananas_1470994628_1477379641_1562164403.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_mfTBD18_qEPOHkT.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129602",
                            "field1": "l'abc della merenda ",
                            "field2": "parmareggio",
                            "field3": "con parmigiano reggiano dop/",
                            "field4": "con formaggino",
                            "description": "l'abc della merenda  parmareggio con parmigiano reggiano dop/ con formaggino",
                            "grammage": 0,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "con parmigiano reggiano dop",
                                "con formaggino"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 34.72813901345292,
                                "left": 0.0,
                                "width": 33.3427048299701,
                                "height": 16.142096412556054
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Parmareggio_ABC_Formaggino_1578388763_1578669086_1585157298_15968145_BvdqnXC.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Parmareggio_ABC_Snack_1578388764_1578669085_1585157299_1596814526_1599031460.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_u4W1l1A_ISDM6pO.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "179164",
                            "field1": "prosciutto cotto",
                            "field2": "bechelli",
                            "field3": "gr. 500",
                            "field4": "",
                            "description": "prosciutto cotto bechelli gr. 500",
                            "grammage": 500,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 34.926079035874444,
                                "left": 34.360326163116596,
                                "width": 31.734526228512703,
                                "height": 16.142096412556054
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/bechelli_prosciutto_cotto_sgrassato_prosciuttino_500_g_1557926862.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_Pm0YPrR_QWlHw6s.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130843",
                            "field1": "lo squeeze & go della lola",
                            "field2": "granarolo",
                            "field3": "gr. 85",
                            "field4": "vaniglia/cacao",
                            "description": "lo squeeze & go della lola granarolo gr. 85 vaniglia/cacao",
                            "grammage": 85,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "vaniglia",
                                "cacao"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 34.711673206278036,
                                "left": 66.76629063901348,
                                "width": 31.734526228512703,
                                "height": 16.142096412556054
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/0701179__8002670017939_SqueezeGo_LOLA_cacao_2019_1582120871.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/0701180__8002670017984_SqueezeGo_LOLA_vaniglia_2019_1582120872.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_Cwk9S1u_ntHdLmH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "132146",
                            "field1": "stracchino mini",
                            "field2": "vallelata",
                            "field3": "gr. 100",
                            "field4": "",
                            "description": "stracchino mini vallelata gr. 100",
                            "grammage": 100,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 50.870235426008975,
                                "left": 1.9085368203475312,
                                "width": 31.734526228512703,
                                "height": 16.142096412556054
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Vallelata_Stracchino_mini_100_gr_1437733154.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_u4ua06l_MJfFNw4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129608",
                            "field1": "yogurt alta qualità",
                            "field2": "granarolo",
                            "field3": "gr. 125 x 2",
                            "field4": "linea",
                            "description": "yogurt alta qualità granarolo gr. 125 x 2 linea",
                            "grammage": 250,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 50.909122757847534,
                                "left": 34.056750397047836,
                                "width": 31.734526228512703,
                                "height": 16.142096412556054
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Granarolo_yogurt_banana_125_gx2_1466758114_1529335255.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Granarolo_yogurt_fragola_125_gx2_1466758163_1529335255.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_RF3Lpw3_3DSnTqX.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "183015",
                            "field1": "yogurt magro 0% alla frutta",
                            "field2": "fage total",
                            "field3": "split",
                            "field4": "vari gusti - gr. 170",
                            "description": "yogurt magro 0% alla frutta fage total split vari gusti - gr. 170",
                            "grammage": 170,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "fragola",
                                "mirtilli"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Yogurt",
                            "blueprint": {
                                "top": 50.955016816143505,
                                "left": 67.02044825532512,
                                "width": 31.734526228512703,
                                "height": 16.142096412556054
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Fruyo-Fragola-_1593157489_1593710619_1595608750.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Fruyo-Mirtillo-ITA-3D-20200519_copy-min_0_1592240041_1593710595_1595608751.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_9ywnU09_1CRx293.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130857",
                            "field1": "  ",
                            "field2": "sottilette",
                            "field3": "gr. 285",
                            "field4": "",
                            "description": "   sottilette gr. 285",
                            "grammage": 285,
                            "price": "2.09",
                            "price_label": "€ 2,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Formaggi",
                            "blueprint": {
                                "top": 66.67741031390135,
                                "left": 1.189041479820628,
                                "width": 31.734526228512703,
                                "height": 16.142096412556054
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Sottilette_classiche_g200_1564141010_1568134839_1570210620_157046186_lyYnOQl.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_nnsH5DR_7C5mu6A.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "Sottilette - Classiche",
                                    "data": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/video/Sottilette-Spot.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "176340",
                            "field1": "panna uht spray mix",
                            "field2": "hoplà",
                            "field3": "ml. 250",
                            "field4": "",
                            "description": "panna uht spray mix hoplà ml. 250",
                            "grammage": 250,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 82.30100896860988,
                                "left": 1.0622103886397611,
                                "width": 31.734526228512703,
                                "height": 16.142096412556054
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/hopla_panna_spray_250_ml_1554213217.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_wQcNCRq_HVlUJDg.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231099",
                            "field1": "liberamente",
                            "field2": "casamodena",
                            "field3": "mortadella di pollo",
                            "field4": "gr. 110",
                            "description": "liberamente casamodena mortadella di pollo gr. 110",
                            "grammage": 110,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 76.51625560538119,
                                "left": 60.30422038490285,
                                "width": 12.01625502148729,
                                "height": 21.7397701793722
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/4440_1599031574.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_Un6TL1y_KIZ5nG7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231706",
                            "field1": "liberamente",
                            "field2": "casa modena",
                            "field3": "tacchino arrosto",
                            "field4": "gr. 110",
                            "description": "liberamente casa modena tacchino arrosto gr. 110",
                            "grammage": 110,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 76.39153587443948,
                                "left": 72.24566487995142,
                                "width": 12.01625502148729,
                                "height": 21.7397701793722
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/4441_Tacchino_arrosto_Liberamente_concorso_1594139300_1599031153.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_kldPaDn_HlyZS6E.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231101",
                            "field1": "liberamente",
                            "field2": "casa modena",
                            "field3": "prosciutto cotto",
                            "field4": "gr. 110",
                            "description": "liberamente casa modena prosciutto cotto gr. 110",
                            "grammage": 110,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Salumi",
                            "blueprint": {
                                "top": 76.53096973094172,
                                "left": 84.48833321655458,
                                "width": 12.01625502148729,
                                "height": 21.7397701793722
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/PROSC.COTTO_LIBERAMENTE_CASAMODENA_GR.110_1597913749.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_utxMPhU_BIHKgFb.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 8,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_8_h3eKylv.jpg",
                    "products": [
                        {
                            "item_id": "140387",
                            "field1": "banane",
                            "field2": "chiquita",
                            "field3": "al kg",
                            "field4": "",
                            "description": "banane chiquita al kg",
                            "grammage": null,
                            "price": "1.69",
                            "price_label": "€ 1,69 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 7.491241591928253,
                                "left": 0.0,
                                "width": 31.64782528727579,
                                "height": 23.822869955156957
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Banane_chiquita_shutter_1432799096_1497020155_1536678337.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_e12ySjh_io9DyVh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "138929",
                            "field1": " ",
                            "field2": "uva red globe",
                            "field3": "origine Italia",
                            "field4": "al kg",
                            "description": "  uva red globe origine Italia al kg",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 8.89994394618834,
                                "left": 30.959172096879673,
                                "width": 31.64782528727579,
                                "height": 23.822869955156957
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/uva_red_globe_1471350509_1471603655_1513078840.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_xPdhEds_RZl5enL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "141476",
                            "field1": " ",
                            "field2": "mele royal gala",
                            "field3": "origine Italia ",
                            "field4": "al kg",
                            "description": "  mele royal gala origine Italia  al kg",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 9.955156950672647,
                                "left": 67.15359474261959,
                                "width": 31.64782528727579,
                                "height": 23.822869955156957
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/mele_gala_1553614954.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_BqVGnbx_xeAhM8I.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "140390",
                            "field1": " ",
                            "field2": "patate",
                            "field3": "origine italia",
                            "field4": "sacco da kg. 4",
                            "description": "  patate origine italia sacco da kg. 4",
                            "grammage": 4000,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 31.508548206278032,
                                "left": 0.0,
                                "width": 31.64782528727579,
                                "height": 23.822869955156957
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/patate_in_rete_1_1491485346_1535730182.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_VtxDulT_7tihU1V.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "174225",
                            "field1": " ",
                            "field2": "pomodoro ciliegino",
                            "field3": "origine italia",
                            "field4": "al kg",
                            "description": "  pomodoro ciliegino origine italia al kg",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 31.173276345291494,
                                "left": 33.21587373878924,
                                "width": 31.64782528727579,
                                "height": 23.822869955156957
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/pomodoro_ciliegino_DOK_1519385775_1542019126_1552400265.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_FYeQt47_kxQpmQr.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "131139",
                            "field1": " ",
                            "field2": "zucchine bianche",
                            "field3": "origine Italia",
                            "field4": "al kg",
                            "description": "  zucchine bianche origine Italia al kg",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Verdura",
                            "blueprint": {
                                "top": 31.51205156950674,
                                "left": 68.35217471272422,
                                "width": 31.64782528727579,
                                "height": 23.822869955156957
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/1020252_ZUCCHINE_BIANCHE_1513951630_1593513016.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_XBJYoFN_J1zITZ1.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130927",
                            "field1": "patatine",
                            "field2": "amica chips",
                            "field3": "gr. 400",
                            "field4": "",
                            "description": "patatine amica chips gr. 400",
                            "grammage": 400,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 57.36652186098656,
                                "left": 0.5231782511210763,
                                "width": 30.23881113368834,
                                "height": 27.45901065022422
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/amic_chips_pata_400g_1530524240.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_BB2akNz_pVjy4PB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231897",
                            "field1": "noci",
                            "field2": "cile",
                            "field3": "32+",
                            "field4": "al kg",
                            "description": "noci cile 32+ al kg",
                            "grammage": null,
                            "price": "5.49",
                            "price_label": "€ 5,49 al Kg",
                            "equivalence": 1000,
                            "quantity_step": 100,
                            "grocery_label": "gr.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Ortofrutta",
                            "subcategory": "Frutta",
                            "blueprint": {
                                "top": 84.91872197309416,
                                "left": 5.356631866591929,
                                "width": 30.238811133688333,
                                "height": 15.081278026905832
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/noci_su_piano_1457519338_1496660380_1547143372_1548676458_1549614457_AZC1zY2.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_SGkIGQ1_R3HzpIe.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231899",
                            "field1": "arachidi salate",
                            "field2": "caputo",
                            "field3": "gr. 200",
                            "field4": "",
                            "description": "arachidi salate caputo gr. 200",
                            "grammage": 200,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 61.597883968609864,
                                "left": 28.707424794469357,
                                "width": 30.23881113368834,
                                "height": 15.081278026905832
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/ES_BARATTOLO_SNACK_ARACHIDI_NEW_1599462623.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_nvpP1Vy_9lcbzpU.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231943",
                            "field1": "bruschette",
                            "field2": "panificio del castello",
                            "field3": "con farina ai 5 cereali/grano duro/integrale",
                            "field4": "gr. 300",
                            "description": "bruschette panificio del castello con farina ai 5 cereali/grano duro/integrale gr. 300",
                            "grammage": 300,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "con farina ai 5 cereali",
                                "grano duro",
                                "integrale  "
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 75.20249439461885,
                                "left": 32.75908363695815,
                                "width": 37.90168803718237,
                                "height": 22.177690582959645
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/bruschette_integrali_castello_1599477900.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/bruschette_castello_1599477901.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/5_cereali_1599477902.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_BSi7EYT_xOwHw3U.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "173253",
                            "field1": "patatine classiche con sorpresa",
                            "field2": "salati preziosi ",
                            "field3": "gr. 30",
                            "field4": "lol/bing",
                            "description": "patatine classiche con sorpresa salati preziosi  gr. 30 lol/bing",
                            "grammage": 30,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "lol",
                                "bing"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 58.47393497757849,
                                "left": 57.64850931894619,
                                "width": 40.906494943479075,
                                "height": 23.639644058295968
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/patatine_bing_1574151199.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/patatine_lol_1574151201.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_BZzkmQt_FQ1YvDt.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "132194",
                            "field1": "bomba calabrese",
                            "field2": "delizie di calabria",
                            "field3": "gr. 90",
                            "field4": "",
                            "description": "bomba calabrese delizie di calabria gr. 90",
                            "grammage": 90,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 81.37016535874442,
                                "left": 71.74608236406952,
                                "width": 26.065770973467867,
                                "height": 16.862738228699556
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/BOMBA_CALABRSE_90g_1562605212.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_TBDygxw_yn5Q18h.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 9,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_9_ArQWxm5.jpg",
                    "products": [
                        {
                            "item_id": "138788",
                            "field1": "cornetto classico",
                            "field2": "algida",
                            "field3": "x 8 - gr. 480",
                            "field4": "",
                            "description": "cornetto classico algida x 8 - gr. 480",
                            "grammage": 480,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 7.485604606525911,
                                "left": 0.0,
                                "width": 53.75482512262742,
                                "height": 26.743442098528472
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Algida_CORNETTO_x8_CLASSICO_1582822894_1587979185_1588773471_1589475_QRRLZv9.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_9eQnSO5_ISuNVOH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "136447",
                            "field1": "fiori di merluzzo",
                            "field2": "findus",
                            "field3": "gr. 300",
                            "field4": "",
                            "description": "fiori di merluzzo findus gr. 300",
                            "grammage": 300,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 7.485604606525911,
                                "left": 53.75482512262742,
                                "width": 46.24517487737258,
                                "height": 26.743442098528472
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/407345_4_Fiori_di_Merluzzo_300g_1588181964_1599059785.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_1SrehtH_O1D7eeh.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130945",
                            "field1": "fantasiosità gamberetti e zucchine gr. 250/",
                            "field2": "preparato per risotto e spaghetti gr. 300",
                            "field3": "3 mari",
                            "field4": "",
                            "description": "fantasiosità gamberetti e zucchine gr. 250/ preparato per risotto e spaghetti gr. 300 3 mari",
                            "grammage": 250,
                            "price": "1.89",
                            "price_label": "€ 1,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Gamberetti e zucchine",
                                "Risotto e spaghetti"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 34.22904670505438,
                                "left": 66.05979419918958,
                                "width": 33.9402058008104,
                                "height": 16.89059500959693
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/33410_FantZucchineGamb_Skin_1530526914.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/33424_PrepRisottoSpagh_Skin_1530519896_1599059817.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_i4uedIJ_csu4SJL.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "140232",
                            "field1": "trancio di pesce spada",
                            "field2": "3 mari",
                            "field3": "gr. 375",
                            "field4": "",
                            "description": "trancio di pesce spada 3 mari gr. 375",
                            "grammage": 375,
                            "price": "5.99",
                            "price_label": "€ 5,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Ittico",
                            "blueprint": {
                                "top": 34.22904670505438,
                                "left": 33.77031349968011,
                                "width": 32.28948069950949,
                                "height": 16.89059500959693
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/33024_SpadaTrancio_1536565122.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_HuCpBQE_riDIenE.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "142439",
                            "field1": "i cuori di carciofo",
                            "field2": "la valle degli orti",
                            "field3": "gr. 300",
                            "field4": "",
                            "description": "i cuori di carciofo la valle degli orti gr. 300",
                            "grammage": 300,
                            "price": "2.29",
                            "price_label": "€ 2,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 34.22904670505438,
                                "left": 0.0,
                                "width": 33.77031349968011,
                                "height": 16.89059500959693
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/web_carciofo_vdo_300_1542816451.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_2reltOB_8mB91Zw.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "195308",
                            "field1": "3 croccole",
                            "field2": "findus",
                            "field3": "gr. 300",
                            "field4": "classiche/spinaci",
                            "description": "3 croccole findus gr. 300 classiche/spinaci",
                            "grammage": 300,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classiche",
                                "Spinaci"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Preparati",
                            "blueprint": {
                                "top": 51.11964171465131,
                                "left": 0.0,
                                "width": 33.77031349968011,
                                "height": 15.674984005118361
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/403603987_FINDUS_CROCCOLE_SPINACI_300G_1569309929_1599059957.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/497203_3_Croccole_300g_1569227519_1572257858_1573052082_1575911602_1_jtvt9cK.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_HHJ3Ow5_et1gmI5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "136446",
                            "field1": "piselli novelli",
                            "field2": "findus",
                            "field3": "kg. 1,1",
                            "field4": "",
                            "description": "piselli novelli findus kg. 1,1",
                            "grammage": 1100,
                            "price": "2.69",
                            "price_label": "€ 2,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 51.11964171465131,
                                "left": 33.77031349968011,
                                "width": 32.549850714438044,
                                "height": 15.674984005118361
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/piselli_novelli_1100g_2_1580738891_1582278886_1583755107_1584985359.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_RZ7v1A1_CcMsTDN.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "183306",
                            "field1": "le patatine originali",
                            "field2": "mc cain",
                            "field3": "kg. 1",
                            "field4": "",
                            "description": "le patatine originali mc cain kg. 1",
                            "grammage": 0,
                            "price": "2.39",
                            "price_label": "€ 2,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 51.11964171465131,
                                "left": 66.32016421411815,
                                "width": 33.679835785881856,
                                "height": 15.674984005118361
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Mccain_le_patate_originali_kg_1_1561036831.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_OHzV7zj_9h5M3KQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130872",
                            "field1": "spinaci foglia bella",
                            "field2": "orogel",
                            "field3": "gr. 450",
                            "field4": "",
                            "description": "spinaci foglia bella orogel gr. 450",
                            "grammage": 450,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 66.79462571976967,
                                "left": 66.32016421411815,
                                "width": 33.679835785881856,
                                "height": 15.80294305822137
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/1176_n_Ben_spinaci_fogliaBella_450g_1530639376.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_Guc0nJT_tCsE8R0.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "192090",
                            "field1": "buon minestrone",
                            "field2": "orogel",
                            "field3": "gr. 750",
                            "field4": "",
                            "description": "buon minestrone orogel gr. 750",
                            "grammage": 750,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 66.79462571976967,
                                "left": 33.77031349968011,
                                "width": 32.549850714438044,
                                "height": 15.80294305822137
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Buon-minestrone750g-_1570433090_1570438720.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_ZaROljW_QZZc8sl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "141318",
                            "field1": "fantasia di funghi",
                            "field2": "la valle degli orti",
                            "field3": "gr. 300",
                            "field4": "",
                            "description": "fantasia di funghi la valle degli orti gr. 300",
                            "grammage": 300,
                            "price": "2.50",
                            "price_label": "€ 2,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Verdure",
                            "blueprint": {
                                "top": 66.79462571976967,
                                "left": 0.0,
                                "width": 33.77031349968011,
                                "height": 15.80294305822137
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/25458119_VDO_FANTASIA_DI_FUNGHI_1547722755_1547799957_1548409760.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_KbfYPPV_Spunf8C.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "176917",
                            "field1": "gelato",
                            "field2": "nuii ",
                            "field3": "ice cream adventure",
                            "field4": "gr. 264/268/272 vari gusti",
                            "description": "gelato nuii  ice cream adventure gr. 264/268/272 vari gusti",
                            "grammage": null,
                            "price": "3.49",
                            "price_label": "€ 3,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Cioccolato bianco e vaniglia",
                                "Mandorle e vaniglia",
                                "Caramello salato e noci"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 82.59756877799104,
                                "left": 0.0,
                                "width": 33.77031349968011,
                                "height": 15.674984005118361
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/25410599_NUII_CARAMELLO_E_NOCI_MACADAMIA_1554968762_1561476162_15616_lX8xXwD.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/nuii_cioccolato_bianco_e_vaniglia_java_1561474840_1561626796_1562261419.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/nuii_mandorle_e_vaniglia_di_java_1561474931_1561626796_1562261420.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/nuii-mandorle-vaniglia-di-java_1561474609_1561626797_1562261421.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_qP7eur4_yJc8wsk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "217939",
                            "field1": "gelato artigianale",
                            "field2": "sigel",
                            "field3": "vari gusti",
                            "field4": "vaschetta kg. 1,350",
                            "description": "gelato artigianale sigel vari gusti vaschetta kg. 1,350",
                            "grammage": 1350,
                            "price": "5.98",
                            "price_label": "€ 5,98",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 82.59756877799104,
                                "left": 33.77031349968011,
                                "width": 32.73080614203455,
                                "height": 15.674984005118361
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/0011s_0001_I-Dessert-Gran-Nocciolato_1596010174.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/0011s_0007_I-Dessert-Marasca_1596010174.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/0011s_0008_I-Dessert-Cassata-Siciliana_1596010175.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_ZVDr4l5_z2EdiAH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231759",
                            "field1": "maxibon cereal mix",
                            "field2": "motta",
                            "field3": "gr. 380",
                            "field4": "",
                            "description": "maxibon cereal mix motta gr. 380",
                            "grammage": 380,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Surgelati",
                            "subcategory": "Gelati",
                            "blueprint": {
                                "top": 82.59756877799104,
                                "left": 66.50111964171465,
                                "width": 33.136969503092345,
                                "height": 15.674984005118361
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/PACK-CEREAL-MIX-senza-logo-460x460_1589535164_1599059687.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_5GutdVp_BjV7FxF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 10,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_10_7XkqsuM.jpg",
                    "products": [
                        {
                            "item_id": "130891",
                            "field1": "croissant farciti",
                            "field2": "bauli",
                            "field3": "gr. 250/300",
                            "field4": "vari gusti",
                            "description": "croissant farciti bauli gr. 250/300 vari gusti",
                            "grammage": null,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Cioccolato",
                                "Albicocca"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 7.485604606525911,
                                "left": 0.0,
                                "width": 42.08320004265302,
                                "height": 27.12731925783749
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Croissant_Albicocca_6pz_H_1580402015_1581099548_1581352361_158227823_PR6PXGp.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Croissant_Cioccolato_6pz_H_1580402014_1581099549_1581352362_15822782_qiXDHae.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_1yNTYKf_4vZGyce.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "136278",
                            "field1": "croissant vuoti",
                            "field2": "bauli",
                            "field3": "gr. 200/240",
                            "field4": "vari gusti",
                            "description": "croissant vuoti bauli gr. 200/240 vari gusti",
                            "grammage": 0,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 7.485604606525911,
                                "left": 42.08320004265302,
                                "width": 27.041773299210917,
                                "height": 27.12731925783749
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Croissant_Classico_6pz_H_1580401972_1581352333_1582560088_1591181892_dnyS2q3.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_V5X9nlA_aNDFXgZ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "171647",
                            "field1": "biscotti",
                            "field2": "doria",
                            "field3": "gr. 350/400",
                            "field4": "vari tipi",
                            "description": "biscotti doria gr. 350/400 vari tipi",
                            "grammage": 0,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 34.61292386436341,
                                "left": 0.0,
                                "width": 33.84972808701216,
                                "height": 16.3787587971849
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/doria_Bucaneve_classico_gr_400_1508150939.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/DRILLOFRIENDS_350G_H_1510943585_1546423999.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/doria_integrale_nonna_g._350_1578670621_1586362818.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_BF5RAkk_Q3WEeSe.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231086",
                            "field1": "plumcake classici con yogurt",
                            "field2": "mulino bianco",
                            "field3": "gr. 330",
                            "field4": "",
                            "description": "plumcake classici con yogurt mulino bianco gr. 330",
                            "grammage": 330,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 34.61292386436341,
                                "left": 33.84972808701216,
                                "width": 32.65139155470249,
                                "height": 16.3787587971849
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/15179-1011305-bpy-1021412_MulinoBiancoPlumcakeClasssico330_157951345_H6y5OSQ.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_KEkObx0_XV1dovy.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "218981",
                            "field1": "caffè armonioso",
                            "field2": "kosè",
                            "field3": "",
                            "field4": "gr. 250 x 4",
                            "description": "caffè armonioso kosè gr. 250 x 4",
                            "grammage": 0,
                            "price": "5.59",
                            "price_label": "€ 5,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 34.61292386436341,
                                "left": 66.50111964171465,
                                "width": 33.49888035828535,
                                "height": 16.3787587971849
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/kose_armonioso_250_g_x_4_1596790176.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_bHIo0kx_RMr6WDo.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231595",
                            "field1": "nutella",
                            "field2": "ferrero",
                            "field3": "gr. 900",
                            "field4": "",
                            "description": "nutella ferrero gr. 900",
                            "grammage": 900,
                            "price": "5.99",
                            "price_label": "€ 5,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 50.9916826615483,
                                "left": 66.50111964171465,
                                "width": 33.49888035828535,
                                "height": 15.930902111324375
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Nutella_925GR_1596464139_1596787605_1596787621_1597143598_1598611331_MNLv7Bc.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_SHW00zi_66b4y6M.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "165206",
                            "field1": "crackers semplicissimi",
                            "field2": "doria",
                            "field3": "gr. 245",
                            "field4": "vari tipi",
                            "description": "crackers semplicissimi doria gr. 245 vari tipi",
                            "grammage": 245,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Riso venere e semi di lino",
                                "Grano saraceno e semi di chia"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 50.9916826615483,
                                "left": 33.77031349968011,
                                "width": 32.73080614203455,
                                "height": 15.930902111324375
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Doria_Semplicissimi_grano_saraceno_e_semi_di_chia_245g_1522765608.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Doria_Semplicissimi_riso_venere_e_semi_di_lino_245g_1522765610.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_Ims2Igk_BenhBFK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "177172",
                            "field1": "ciambelline",
                            "field2": "misura",
                            "field3": "gr. 230",
                            "field4": "vari gusti",
                            "description": "ciambelline misura gr. 230 vari gusti",
                            "grammage": 230,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 50.9916826615483,
                                "left": 0.0,
                                "width": 33.77031349968011,
                                "height": 15.930902111324375
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Misura_fibrextra-ciambelline_integrali_1573225089_1573579528_1596722_bl6yZED.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_gTCNcKR_NCALTQ4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "137608",
                            "field1": "fette biscottate",
                            "field2": "misura",
                            "field3": "gr. 320",
                            "field4": "vari tipi",
                            "description": "fette biscottate misura gr. 320 vari tipi",
                            "grammage": 320,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Integrali",
                                "Senza zuccheri aggiunti"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 66.92258477287267,
                                "left": 0.0,
                                "width": 33.77031349968011,
                                "height": 15.80294305822137
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/misura_fette_biscottate_dolce_senza_1568036062_1574095434_1574510100_aCeTW5h.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/misura_fibraextra_fette__biscottate_1568036061_1574095435_1574510100_FakM3eR.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_hCLZxB7_5i2yLba.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "180547",
                            "field1": "girella classica cacao",
                            "field2": "motta",
                            "field3": "gr. 280",
                            "field4": "",
                            "description": "girella classica cacao motta gr. 280",
                            "grammage": 280,
                            "price": "1.89",
                            "price_label": "€ 1,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 66.92258477287267,
                                "left": 33.77031349968011,
                                "width": 32.459373000639786,
                                "height": 15.80294305822137
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/34212_MottaGirellaCacaox8_1551969866_1552034681_1558941931.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_Qnaulea_3vnhKLk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "211956",
                            "field1": "latte uht parzialmente scremato",
                            "field2": "granarolo",
                            "field3": "lt. 1",
                            "field4": "",
                            "description": "latte uht parzialmente scremato granarolo lt. 1",
                            "grammage": 0,
                            "price": "0.72",
                            "price_label": "€ 0,72",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Self Service",
                            "subcategory": "Latte",
                            "blueprint": {
                                "top": 66.92258477287267,
                                "left": 66.2296865003199,
                                "width": 33.77031349968011,
                                "height": 15.80294305822137
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/granarolo_Latte_ps_1481620422_1532963929_1533059794_1558600994_15651_Ebqf1V6.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_jWvMww1_UmKwOnQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "139831",
                            "field1": "nesquik",
                            "field2": "nestlè",
                            "field3": "gr. 500",
                            "field4": "",
                            "description": "nesquik nestlè gr. 500",
                            "grammage": 500,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 82.72552783109404,
                                "left": 66.2296865003199,
                                "width": 33.77031349968011,
                                "height": 15.419065898912347
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/nesquick_500_gr_polvere_1472130506_1472197790.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_FzkQNzc_uCeoSzD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "172104",
                            "field1": "nesquik cereali",
                            "field2": "nestlè ",
                            "field3": "gr. 375",
                            "field4": "",
                            "description": "nesquik cereali nestlè  gr. 375",
                            "grammage": 375,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 82.72552783109404,
                                "left": 33.679835785881856,
                                "width": 32.549850714438044,
                                "height": 15.419065898912347
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Nesquik_cereali_375gr_1525271461_1527150796_1542631675.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_w1KIJ2D_m6mLy0F.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "211173",
                            "field1": "bevande vegetali",
                            "field2": "scotti",
                            "field3": "chiccolat lt. 1",
                            "field4": "vari gusti",
                            "description": "bevande vegetali scotti chiccolat lt. 1 vari gusti",
                            "grammage": 0,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Riso",
                                "Fibre"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 82.72552783109404,
                                "left": 0.0,
                                "width": 33.679835785881856,
                                "height": 15.419065898912347
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/principale_8001860810008_1587482830.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/principale_8001860250200_1593422190.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_QNEn9gh_qkFi9tv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 11,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_11_EVmSJ7J.jpg",
                    "products": [
                        {
                            "item_id": "136328",
                            "field1": "oro ciok barrette ",
                            "field2": "saiwa",
                            "field3": "x 6 - gr. 162",
                            "field4": "",
                            "description": "oro ciok barrette  saiwa x 6 - gr. 162",
                            "grammage": 162,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 7.417840375586855,
                                "left": 28.754303599374023,
                                "width": 20.18341158059468,
                                "height": 26.94835680751174
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/ORO_CIOK_BARRETTA_162G_22CA_1533109497_1533659503.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_st2jlG4_zCaf3dd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "212849",
                            "field1": "oro ciok soft",
                            "field2": "saiwa",
                            "field3": "gr. 30 x 5",
                            "field4": "",
                            "description": "oro ciok soft saiwa gr. 30 x 5",
                            "grammage": 150,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 7.605633802816902,
                                "left": 49.468857589984346,
                                "width": 25.627621283255085,
                                "height": 26.94835680751174
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/l_64363_1589558368.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_8PT4MfR_SQdWwdl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "216748",
                            "field1": "pocket ",
                            "field2": "oro ciok",
                            "field3": "gr. 160",
                            "field4": "",
                            "description": "pocket  oro ciok gr. 160",
                            "grammage": 160,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 7.323943661971831,
                                "left": 75.43466353677621,
                                "width": 24.565336463223787,
                                "height": 26.94835680751174
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/secondaria_7622201447533_1594637117.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_a5iRtJe_Qox6GDY.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "139784",
                            "field1": " bounty x6 gr. 171/mars x4 gr. 180/snickers x4 gr. 200",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": " bounty x6 gr. 171/mars x4 gr. 180/snickers x4 gr. 200",
                            "grammage": 0,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 34.460093896713616,
                                "left": 0.13278560250391236,
                                "width": 33.594757433489825,
                                "height": 16.619718309859156
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/193675_-_Mars_Multipack_x4_1534945234.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_RUHbNAG_ODMH4Hs.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "137551",
                            "field1": "cornetti",
                            "field2": "misura",
                            "field3": "gr. 240/290/300",
                            "field4": "vari gusti",
                            "description": "cornetti misura gr. 240/290/300 vari gusti",
                            "grammage": 0,
                            "price": "2.39",
                            "price_label": "€ 2,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 34.74178403755869,
                                "left": 33.860328638497656,
                                "width": 32.13411580594679,
                                "height": 16.150234741784036
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/misura_cornetti_miele_1567584910_1571755012_1579084671_1579111892_15_t4eVluj.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/xfibrextra-cornetti_cioccolato-pack.png.pagespeed.ic.vZ1IsyE-sn_1587_mAEge7A.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_hEHJeJ5_JccaV9D.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "189093",
                            "field1": "tavoletta di cioccolato fondente",
                            "field2": "cote d'or",
                            "field3": "spessa extra gr. 200/con nocciola gr. 180",
                            "field4": "",
                            "description": "tavoletta di cioccolato fondente cote d'or spessa extra gr. 200/con nocciola gr. 180",
                            "grammage": 0,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 34.83568075117371,
                                "left": 66.40524256651017,
                                "width": 33.594757433489825,
                                "height": 16.244131455399064
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/19554_CorteDOrFondenteExtraIntenso200g_1566406022_1567609550.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/19555_CorteDOrNoccioleIntereExtra180gr_1566406023_1567609551.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_e2EmRCm_eTMYteI.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "175056",
                            "field1": "tavoletta di cioccolato",
                            "field2": "lindt",
                            "field3": "gr. 100",
                            "field4": "con - mandorle - nocciole vari tipi",
                            "description": "tavoletta di cioccolato lindt gr. 100 con - mandorle - nocciole vari tipi",
                            "grammage": 100,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Mandorle",
                                "Nocciole"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 51.17370892018779,
                                "left": 0.0,
                                "width": 33.72754303599374,
                                "height": 15.774647887323944
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/lindt_TAV_FONDENTE_E_MANDORLE_1_1505743479_1546423875.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/lindt_TAV_FONDENTE_NOCCIOLE_IGP_1_1505743477_1546423876.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/linft_TAV_LATTE_E_MANDORLE_1_1505743478_1546423876.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/linft_TAV_LATTE_NOCCIOLE_IGP_1_1505743478_1546423877.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_uYKY8ND_adncdR4.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "189106",
                            "field1": " ",
                            "field2": "m&m's",
                            "field3": "original gr. 200/choco gr. 170/crispy gr 170",
                            "field4": "",
                            "description": "  m&m's original gr. 200/choco gr. 170/crispy gr 170",
                            "grammage": 0,
                            "price": "2.09",
                            "price_label": "€ 2,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 51.07981220657277,
                                "left": 33.80015649452269,
                                "width": 32.665258215962446,
                                "height": 15.586854460093896
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/MM_s_Peanut_200_gr_1567611541.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_IEhivjj_KwecV8g.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231596",
                            "field1": "twix x3 gr. 150",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "description": "twix x3 gr. 150",
                            "grammage": 150,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 51.26760563380282,
                                "left": 66.46541471048513,
                                "width": 33.534585289514865,
                                "height": 15.586854460093896
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/twix_3x2_1534945471_1598631706.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_L4PMBpB_CJbzbYl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "189096",
                            "field1": "tavoletta di cioccolato",
                            "field2": "novi",
                            "field3": "gr. 80/100",
                            "field4": "vari gusti",
                            "description": "tavoletta di cioccolato novi gr. 80/100 vari gusti",
                            "grammage": 0,
                            "price": "1.50",
                            "price_label": "€ 1,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 67.04225352112677,
                                "left": 0.0,
                                "width": 26.231377151799684,
                                "height": 15.586854460093896
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/56404-r66_novi_riso_soffiato_cioccolato_latte_1547737452_1567610288.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/56405-r66_novi_5_cereali_cioccolato_latte_1547737453_1567610288.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/361187_noovi_latte_finissimo_100_1487929048_1535565487_1598631921.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/361193_novi_fondente_100_1487929049_1535565488_1598631922.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_pMhJbFr_NPWJ0O5.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "189097",
                            "field1": "canestrellini",
                            "field2": "biscottificio del sassello",
                            "field3": "gr. 135",
                            "field4": "",
                            "description": "canestrellini biscottificio del sassello gr. 135",
                            "grammage": 135,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 66.94835680751174,
                                "left": 26.15876369327074,
                                "width": 23.442879499217526,
                                "height": 15.586854460093896
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/canestrellini_del_sassello_1552492485_1592318310_1596115092_1598631760.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_pJcJvKI_RSnfIi8.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "163438",
                            "field1": "choco orange",
                            "field2": "balconi",
                            "field3": "gr. 350",
                            "field4": "",
                            "description": "choco orange balconi gr. 350",
                            "grammage": 350,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 66.94835680751174,
                                "left": 50.32574334898279,
                                "width": 23.442879499217526,
                                "height": 15.586854460093896
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/chocoorange_1550851730.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_Hx1PxZE_QcgAeOU.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "175980",
                            "field1": "mini tiramisù ",
                            "field2": "balconi",
                            "field3": "gr. 300",
                            "field4": "",
                            "description": "mini tiramisù  balconi gr. 300",
                            "grammage": 300,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 66.85446009389672,
                                "left": 73.82879499217528,
                                "width": 26.171205007824724,
                                "height": 15.586854460093896
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/tiramisunewpacksoon-3_1551277062.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_atvPgs4_tdCWctQ.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130911",
                            "field1": "biscotti",
                            "field2": "oreo",
                            "field3": "doppia crema gr. 157/choco brownie gr. 154/golden gr.154",
                            "field4": "",
                            "description": "biscotti oreo doppia crema gr. 157/choco brownie gr. 154/golden gr.154",
                            "grammage": 0,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Doppia Crema",
                                "Choco Brownie",
                                "Golden"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 82.72300469483568,
                                "left": 0.0,
                                "width": 26.171205007824724,
                                "height": 15.586854460093896
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Oreo_double_doppia_crema_1527095308_1552487251.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Oreo_Golden_Vaniglia_1546619550_1552487705.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_hv4VlMk_jgL6YII.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "142660",
                            "field1": "biscotti original",
                            "field2": "oreo",
                            "field3": "gr. 154",
                            "field4": "",
                            "description": "biscotti original oreo gr. 154",
                            "grammage": 154,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 82.62910798122066,
                                "left": 26.15876369327074,
                                "width": 23.7810641627543,
                                "height": 15.586854460093896
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/tubo-oreo-flash_1497865448_1509793024.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_uSWu5v8_xuVgjhP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "132222",
                            "field1": "cipster",
                            "field2": "saiwa",
                            "field3": "gr. 132",
                            "field4": "",
                            "description": "cipster saiwa gr. 132",
                            "grammage": 132,
                            "price": "1.69",
                            "price_label": "€ 1,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Salati",
                            "blueprint": {
                                "top": 82.62910798122066,
                                "left": 50.192957746478875,
                                "width": 23.64827856025039,
                                "height": 15.586854460093896
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cipster_Multipack_6_Buste_132_g_1495557330_1496247556.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_4FqFdtS_GrDISxl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "136325",
                            "field1": "tender break",
                            "field2": "milka",
                            "field3": "gr. 156",
                            "field4": "",
                            "description": "tender break milka gr. 156",
                            "grammage": 156,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack Dolci",
                            "blueprint": {
                                "top": 82.62910798122066,
                                "left": 73.96158059467919,
                                "width": 26.03841940532081,
                                "height": 15.586854460093896
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Milka_TENDER_BREAK_156G_1530782914_1532945476.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_WDS78Rr_sEqCkHV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 12,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_12_pcoEUWg.jpg",
                    "products": [
                        {
                            "item_id": "130918",
                            "field1": "pasta formati tradizionali",
                            "field2": "divella",
                            "field3": "gr. 500 ",
                            "field4": "varie trafile",
                            "description": "pasta formati tradizionali divella gr. 500  varie trafile",
                            "grammage": 500,
                            "price": "0.39",
                            "price_label": "€ 0,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 7.793427230046948,
                                "left": 0.0,
                                "width": 52.78849765258216,
                                "height": 26.854460093896716
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Divella_spaghetti_gr_500_1443010063_1488961383.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/1452617604_1526632698.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/1452617429_1526632699.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_AJ2I0um_NOKfzAU.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "141264",
                            "field1": "olio extra vergine di oliva delizia",
                            "field2": "carapelli",
                            "field3": "cl. 75",
                            "field4": "",
                            "description": "olio extra vergine di oliva delizia carapelli cl. 75",
                            "grammage": 750,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Olio",
                            "blueprint": {
                                "top": 7.605633802816902,
                                "left": 54.11635367762129,
                                "width": 45.88364632237871,
                                "height": 26.854460093896716
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/0021958_CARAPELLI_DELIZIA_1524748459_c10rphK.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_0OecR53_J6diWUq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "136299",
                            "field1": "carne in scatola ",
                            "field2": "simmenthal",
                            "field3": "gr. 90 x 3",
                            "field4": "",
                            "description": "carne in scatola  simmenthal gr. 90 x 3",
                            "grammage": 270,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 34.647887323943664,
                                "left": 0.0,
                                "width": 33.40179968701095,
                                "height": 16.338028169014084
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Simmenthal_carne_90_gr_x_3.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_XyYpipa_nQEJUwF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "132237",
                            "field1": "legumi",
                            "field2": "valfrutta",
                            "field3": "gr. 370",
                            "field4": "ceci/fagioli vari tipi/lenticchie",
                            "description": "legumi valfrutta gr. 370 ceci/fagioli vari tipi/lenticchie",
                            "grammage": 370,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Ceci",
                                "Fagioli",
                                "Lenticchie"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 34.55399061032864,
                                "left": 33.860328638497656,
                                "width": 32.339514866979655,
                                "height": 16.338028169014084
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/temp_BLOB1007444206_1515173390.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/valfrutta_Cannellini_g_580_1503412303_1531747500.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_f4eIiYQ_SRXSsL2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "207672",
                            "field1": "brodo granulare ",
                            "field2": "knorr",
                            "field3": "gr. 150",
                            "field4": "classico/vegatale",
                            "description": "brodo granulare  knorr gr. 150 classico/vegatale",
                            "grammage": 150,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Classico",
                                "Vegetale"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 34.647887323943664,
                                "left": 66.39280125195617,
                                "width": 33.607198748043814,
                                "height": 16.338028169014084
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/knorr_granulare_classico_1580911670_1583748121.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/knorr_granulare_vegetale_1580911670_1583748121.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_yHibEl4_acwE8DC.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231594",
                            "field1": "farina tipo \"00\"",
                            "field2": "granoro",
                            "field3": "kg. 1",
                            "field4": "",
                            "description": "farina tipo \"00\" granoro kg. 1",
                            "grammage": 0,
                            "price": "0.50",
                            "price_label": "€ 0,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 51.07981220657277,
                                "left": 0.0,
                                "width": 33.607198748043814,
                                "height": 15.492957746478874
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/GRANORO_Farina_00_kg1_1541175392_1591265378_1592318515_1592841387_1598631151.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_m1n2KE1_fZx0C3h.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130916",
                            "field1": "mais ",
                            "field2": "valfrutta",
                            "field3": "gr. 160 x 3+1",
                            "field4": "",
                            "description": "mais  valfrutta gr. 160 x 3+1",
                            "grammage": 640,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 51.17370892018779,
                                "left": 33.860328638497656,
                                "width": 32.279342723004696,
                                "height": 15.492957746478874
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/MAIS_VALFRUTTA_WAKU_GR.160X31_1559569696.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_yhSbcGk_ZXU5qRk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "192123",
                            "field1": "olio di semi di girasole",
                            "field2": "basso",
                            "field3": "lt. 1",
                            "field4": "",
                            "description": "olio di semi di girasole basso lt. 1",
                            "grammage": 0,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 51.26760563380282,
                                "left": 66.39280125195617,
                                "width": 33.607198748043814,
                                "height": 15.492957746478874
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/olio_basso_1570616650.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_v2EGq4c_Xhak1vk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "190806",
                            "field1": "la passata pomodorissimo",
                            "field2": "santa rosa",
                            "field3": "gr. 700",
                            "field4": "",
                            "description": "la passata pomodorissimo santa rosa gr. 700",
                            "grammage": 700,
                            "price": "0.59",
                            "price_label": "€ 0,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "blueprint": {
                                "top": 66.94835680751174,
                                "left": 0.2655712050078247,
                                "width": 33.607198748043814,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/1022_SantarosaPomodorissimo_1548177586_1550490268_1569225334.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_FG2oZux_ONNfIvP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "180550",
                            "field1": "pasta integrale",
                            "field2": "garofalo",
                            "field3": "gr. 500",
                            "field4": "varie trafile",
                            "description": "pasta integrale garofalo gr. 500 varie trafile",
                            "grammage": 500,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fusilli",
                                "Mezze maniche rigate"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Pasta",
                            "blueprint": {
                                "top": 66.94835680751174,
                                "left": 34.12589984350548,
                                "width": 32.013771517996865,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Garofalo_pasta_integrale_mezze_maniche_rigate_500gr_1526462210_15300_FvJsdtw.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Garofalo_pasta_integrale_fusilli_500gr_1526462210_1530023157_1558942217.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_ENPDayS_QW2MdTS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "Pasta Garofalo",
                                    "data": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/video/Pasta-GAROFALO-Un-Vero-Spettacolo.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "132234",
                            "field1": "tonno all'olio d'oliva",
                            "field2": "palmera",
                            "field3": "gr. 80 x 3",
                            "field4": "",
                            "description": "tonno all'olio d'oliva palmera gr. 80 x 3",
                            "grammage": 240,
                            "price": "1.89",
                            "price_label": "€ 1,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 66.94835680751174,
                                "left": 66.26001564945227,
                                "width": 33.73998435054773,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/PALMERA_tonno_olio_oliva_3x80g_1493798305_1529686717.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_OcIB9K5_1o3Ca3h.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "211984",
                            "field1": "soia drink 100% vegetale",
                            "field2": "tre valli hoplà",
                            "field3": "lt. 1",
                            "field4": "",
                            "description": "soia drink 100% vegetale tre valli hoplà lt. 1",
                            "grammage": 0,
                            "price": "1.29",
                            "price_label": "€ 1,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Colazione",
                            "blueprint": {
                                "top": 82.44131455399061,
                                "left": 0.0,
                                "width": 33.73998435054773,
                                "height": 15.77464788732394
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/soia-drink-1000ml_1588147308_1588754244.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_fMJh870_HPXKm6H.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231620",
                            "field1": "olive nere intere/denocciolate",
                            "field2": "attinà",
                            "field3": "lattina gr. 350",
                            "field4": "",
                            "description": "olive nere intere/denocciolate attinà lattina gr. 350",
                            "grammage": 350,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Intere",
                                "Denocciolate"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 82.44131455399061,
                                "left": 33.860328638497656,
                                "width": 32.013771517996865,
                                "height": 15.77464788732394
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/OLIVE-NERE-DENOCC-large_1599117904.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/OLIVE-NERE-large_1599117904.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_twmTeLT_ZHyytiG.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "214729",
                            "field1": "funghi poker",
                            "field2": "attinà",
                            "field3": "gr. 314",
                            "field4": "",
                            "description": "funghi poker attinà gr. 314",
                            "grammage": 314,
                            "price": "2.09",
                            "price_label": "€ 2,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 82.53521126760563,
                                "left": 66.52558685446009,
                                "width": 33.474413145539906,
                                "height": 15.586854460093894
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/SP572_POKER_DI_FUNGHI_CAS_-_Vaso_320ml_1592205788.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_wehI6Sy_BS3z81m.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 13,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_13_zfUVqly.jpg",
                    "products": [
                        {
                            "item_id": "129763",
                            "field1": "acqua naturale fonte del pollino",
                            "field2": "san benedetto",
                            "field3": "lt. 2 x 6",
                            "field4": "",
                            "description": "acqua naturale fonte del pollino san benedetto lt. 2 x 6",
                            "grammage": 12000,
                            "price": "1.50",
                            "price_label": "€ 1,50",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Acqua",
                            "blueprint": {
                                "top": 6.666666666666667,
                                "left": 0.13278560250391236,
                                "width": 55.311424100156486,
                                "height": 27.417840375586856
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/San_Benedetto_Ecogreen_2lt__Bottiglie_x6_1595953223_1598874181.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_epYKzIb_kY6GVib.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "137634",
                            "field1": "birra",
                            "field2": "dreher",
                            "field3": "cl. 33 x 3",
                            "field4": "",
                            "description": "birra dreher cl. 33 x 3",
                            "grammage": 990,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 7.042253521126761,
                                "left": 56.772065727699534,
                                "width": 43.22793427230047,
                                "height": 27.417840375586856
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/dreher_3x33_corretto_1588085576_1591869452_1593535377_1593787993_159_7To2N8h.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_Xujdbh6_7W73ZRF.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "139814",
                            "field1": "birra",
                            "field2": "heineken",
                            "field3": "cl. 25 x 6",
                            "field4": "",
                            "description": "birra heineken cl. 25 x 6",
                            "grammage": 1500,
                            "price": "3.99",
                            "price_label": "€ 3,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 34.460093896713616,
                                "left": 0.0,
                                "width": 33.40179968701095,
                                "height": 16.71361502347418
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Heineken_birra_25_cl_x_6_1533033855.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_3ypZF5X_sKf81DB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "174045",
                            "field1": "birra ",
                            "field2": "nastro azzurro",
                            "field3": "cl. 66",
                            "field4": "",
                            "description": "birra  nastro azzurro cl. 66",
                            "grammage": 660,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Birre",
                            "blueprint": {
                                "top": 34.460093896713616,
                                "left": 33.72754303599374,
                                "width": 32.60508607198748,
                                "height": 16.525821596244132
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/nastro_azzurro_birra_66_cl_1439309571_1540309773.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_OFe6asr_6vKvx2u.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "139805",
                            "field1": "bevanda energetica",
                            "field2": "gatorade ",
                            "field3": "ml. 500",
                            "field4": "arancia rossa/arancia/limone/cool blue",
                            "description": "bevanda energetica gatorade  ml. 500 arancia rossa/arancia/limone/cool blue",
                            "grammage": 500,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "arancia rossa",
                                "arancia",
                                "limone",
                                "cool blue"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 34.647887323943664,
                                "left": 66.1998435054773,
                                "width": 33.800156494522696,
                                "height": 16.525821596244132
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/8001160000888_Principale_1520607952.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/8001160001892_Principale_1520607953.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/8001160000949_Principale_1520607952_1535449165.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_SOtmqOn_KD91i4l.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "169852",
                            "field1": "prosecco doc treviso extra dry       ",
                            "field2": "millage",
                            "field3": "cl. 75",
                            "field4": "",
                            "description": "prosecco doc treviso extra dry        millage cl. 75",
                            "grammage": 750,
                            "price": "5.49",
                            "price_label": "€ 5,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 51.07981220657277,
                                "left": 0.0,
                                "width": 33.800156494522696,
                                "height": 15.586854460093896
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/prosecco_la_marca_d.o.c.millage1200x1200_1545043863.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_YA5uiCh_vhkHI3E.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "132259",
                            "field1": "succo",
                            "field2": "bravo",
                            "field3": "lt. 2",
                            "field4": "vari gusti",
                            "description": "succo bravo lt. 2 vari gusti",
                            "grammage": 2000,
                            "price": "1.59",
                            "price_label": "€ 1,59",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Succhi",
                            "blueprint": {
                                "top": 51.36150234741785,
                                "left": 33.72754303599374,
                                "width": 32.33951486697966,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Rauch_bravo_Ace_2_lt_1430243137_1506085864.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/bravo_red_1527860968.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/bravo_lt.2_multivitaminico_1531124119.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_5USLU9p_KR5IMGH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "136301",
                            "field1": "succhi bio",
                            "field2": "valfrutta",
                            "field3": "ml. 125 x 6",
                            "field4": "vari gusti",
                            "description": "succhi bio valfrutta ml. 125 x 6 vari gusti",
                            "grammage": 750,
                            "price": "2.39",
                            "price_label": "€ 2,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Succhi",
                            "blueprint": {
                                "top": 51.07981220657277,
                                "left": 66.33262910798123,
                                "width": 33.66737089201878,
                                "height": 15.680751173708918
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/0061292_valfrutta_bio_pera_125_ml_x_6_1493749634.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/0061295_valfrutta_bio_pesca_125_ml_x_6_1493749635.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_ltk8h51_d5vtEPp.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129768",
                            "field1": "bibite",
                            "field2": "san benedetto",
                            "field3": "lt 1,5",
                            "field4": "linea",
                            "description": "bibite san benedetto lt 1,5 linea",
                            "grammage": 1500,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "blueprint": {
                                "top": 66.94835680751174,
                                "left": 0.0,
                                "width": 33.66737089201878,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/san_benedetto_ben_cola_15_lt.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/San_benedetto_cedrata_Lt_15_1446114045_1516098976.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/SB_Allegra_15lt_1526402109.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_CrxOCyC_BM5zXaH.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "129780",
                            "field1": "vino cirò doc",
                            "field2": "enotria",
                            "field3": "cl. 75",
                            "field4": "bianco/rosso/rosato ",
                            "description": "vino cirò doc enotria cl. 75 bianco/rosso/rosato ",
                            "grammage": 750,
                            "price": "3.29",
                            "price_label": "€ 3,29",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Bianco",
                                "Rosso",
                                "Rosato"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 66.94835680751174,
                                "left": 33.72754303599374,
                                "width": 32.47230046948357,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/ciro_vini_1533638716.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_2iqkYHd_S1gy80F.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130951",
                            "field1": "vino",
                            "field2": "tavernello",
                            "field3": "brik lt. 1",
                            "field4": "bianco/rosso/rosato",
                            "description": "vino tavernello brik lt. 1 bianco/rosso/rosato",
                            "grammage": 0,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e Spumanti",
                            "blueprint": {
                                "top": 67.13615023474179,
                                "left": 66.26001564945227,
                                "width": 33.739984350547736,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Tavernello_Rosso_Brick_Lt_1.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Tavernello_Bianco_Brick_Lt_1_1467907643_1506066717.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/tavernello_vino_rosato_brik_da_1_litro_1488269678_1488292254_1506066717.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_DOM1GQc_07C4vY7.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130953",
                            "field1": "omogeneizzati di carne",
                            "field2": "plasmon",
                            "field3": "gr. 80 x 2",
                            "field4": "vari gusti",
                            "description": "omogeneizzati di carne plasmon gr. 80 x 2 vari gusti",
                            "grammage": 160,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 82.91079812206573,
                                "left": 20.714553990610323,
                                "width": 22.18763693270736,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Plasmon_omo_vitello_2X80_gr_1589877187_1593427839.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Plasmon_omo_prosciutto_2X80_gr_1589877186_1593427840.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_MWqIk2s_rA3Noqq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "130954",
                            "field1": "omogeneizzati di frutta",
                            "field2": "plasmon",
                            "field3": "gr. 104 x 2",
                            "field4": "vari gusti",
                            "description": "omogeneizzati di frutta plasmon gr. 104 x 2 vari gusti",
                            "grammage": 208,
                            "price": "1.19",
                            "price_label": "€ 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 82.91079812206573,
                                "left": 43.15532081377151,
                                "width": 22.98435054773083,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Plasmon_omo_4_frutti_2X104_1589877222_1593427886.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Plasmon_omo_pera_2x104_1589877224_1593427886.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_U0xOioT_0RCvY0s.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "184632",
                            "field1": "il biscotto dei bambini",
                            "field2": "plasmon",
                            "field3": "gr. 600 x 2",
                            "field4": "",
                            "description": "il biscotto dei bambini plasmon gr. 600 x 2",
                            "grammage": 1200,
                            "price": "6.99",
                            "price_label": "€ 6,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "blueprint": {
                                "top": 82.62910798122066,
                                "left": 67.32230046948357,
                                "width": 32.677699530516435,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/0072774_Plasmon_Biscotti_2x600_1529996741_1562665502.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_o2IjT6W_Kccr9Jk.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 14,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_14_IIh0TSc.jpg",
                    "products": [
                        {
                            "item_id": "132298",
                            "field1": "bagnoschiuma",
                            "field2": "malizia",
                            "field3": "lt. 1",
                            "field4": "vari tipi",
                            "description": "bagnoschiuma malizia lt. 1 vari tipi",
                            "grammage": null,
                            "price": "1.39",
                            "price_label": "€ 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Argan e Vaniglia",
                                "Muschio Bianco"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 7.699530516431924,
                                "left": 0.0,
                                "width": 53.18685446009389,
                                "height": 26.760563380281692
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/MALIZIA_BAGNO_MUSCHIO_BIANCO_1L_1438333948_1440003397.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/MALIZIA_BAGNO_ARGAN_1L_1438333926_1440003408.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_TlBlWpz_ohLiiSe.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "206773",
                            "field1": "shampoo ml. 225/250/balsamo ml. 220",
                            "field2": "head & shoulders",
                            "field3": "vari trattamenti",
                            "field4": "",
                            "description": "shampoo ml. 225/250/balsamo ml. 220 head & shoulders vari trattamenti",
                            "grammage": null,
                            "price": "1.99",
                            "price_label": "€ 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Capelli",
                            "blueprint": {
                                "top": 7.511737089201877,
                                "left": 53.58521126760564,
                                "width": 46.41478873239436,
                                "height": 26.760563380281692
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Head__Shoulders_balsamo_supreme_idrata_1568971633_1575908693_1582626941.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Head__Shoulders_supreme_idrata_1568971632_1575908693_1582626941.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_zWOOqAR_6LPEAYq.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "197447",
                            "field1": "pannolini dry fit",
                            "field2": "chicco",
                            "field3": "varie misure",
                            "field4": "",
                            "description": "pannolini dry fit chicco varie misure",
                            "grammage": null,
                            "price": "3.90",
                            "price_label": "€ 3,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 34.55399061032864,
                                "left": 66.06705790297339,
                                "width": 33.932942097026604,
                                "height": 16.525821596244132
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/CHICCO_PANNOLINI_N.2_MINI_X25_3-6KG_1552322672_1559816710_1573546445.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_IjLF7bE_deJI5sD.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "137647",
                            "field1": "acqua micellare",
                            "field2": "garnier",
                            "field3": "ml. 400",
                            "field4": "fresh/pelli sensibili",
                            "description": "acqua micellare garnier ml. 400 fresh/pelli sensibili",
                            "grammage": 400,
                            "price": "2.69",
                            "price_label": "€ 2,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "Fresh",
                                "Pelli sensibili"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 51.17370892018779,
                                "left": 66.06705790297339,
                                "width": 33.932942097026604,
                                "height": 15.492957746478874
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Skinactive_Render_Acqua_Micellare_Fresh_400_ml_v2_P2_1566896010.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Acqua_micellare_rosa_2018_v6_P2_1566896010.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_9Uqg6lH_PloOiWi.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "166805",
                            "field1": "salviettine baby easy",
                            "field2": "fresh&clean",
                            "field3": "pz. 60",
                            "field4": "",
                            "description": "salviettine baby easy fresh&clean pz. 60",
                            "grammage": 0,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 66.85446009389672,
                                "left": 66.06705790297339,
                                "width": 33.932942097026604,
                                "height": 15.492957746478874
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/fresh-clean-salviette-umidificate-bimbi-baby-easy-60-pz_1537461303.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_47FjCpn_YDmh1bd.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231705",
                            "field1": "sapone",
                            "field2": "palmolive",
                            "field3": "ricarica vari tpi",
                            "field4": "ml. 300",
                            "description": "sapone palmolive ricarica vari tpi ml. 300",
                            "grammage": 300,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 82.62910798122066,
                                "left": 66.06705790297339,
                                "width": 33.932942097026604,
                                "height": 15.492957746478874
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/principale_8003520013064_1599031123.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/principale_8003520013187_1599031124.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_a34JtG7_0ebJgAv.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "210062",
                            "field1": "asciugamani igienizzanti defend",
                            "field2": "nicky",
                            "field3": "pz. 100",
                            "field4": "",
                            "description": "asciugamani igienizzanti defend nicky pz. 100",
                            "grammage": null,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 34.647887323943664,
                                "left": 39.11158059467919,
                                "width": 26.762519561815335,
                                "height": 17.558685446009388
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Nicky-Defend_1_-33_1586448516.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_fJShljC_vLf7y49.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "170357",
                            "field1": "salviettine disinfettanti",
                            "field2": "fresh&clean",
                            "field3": "pz. 12",
                            "field4": "",
                            "description": "salviettine disinfettanti fresh&clean pz. 12",
                            "grammage": 0,
                            "price": "0.79",
                            "price_label": "€ 0,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 51.54929577464789,
                                "left": 41.5017214397496,
                                "width": 24.106807511737088,
                                "height": 15.211267605633804
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/11116689_Freshe_e_Clean_Salviettine_Disinfettanti_x12_1545921701_1545986720.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_hppqnSW_ybRGjhj.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "188427",
                            "field1": "disinfettante gel mani",
                            "field2": "amuchina",
                            "field3": "ml. 80",
                            "field4": "",
                            "description": "disinfettante gel mani amuchina ml. 80",
                            "grammage": 80,
                            "price": "2.49",
                            "price_label": "€ 2,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Corpo",
                            "blueprint": {
                                "top": 51.455399061032864,
                                "left": 22.64616588419405,
                                "width": 17.998669796557117,
                                "height": 15.211267605633804
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/DISINFETTANTE_AMUCHINA_GEL_MANI_X-GERM_80_ML_1562052712_1566832218.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_nP5fDU6_H0lbBcP.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "231704",
                            "field1": "mascherine chirurgiche",
                            "field2": "sicura protection",
                            "field3": "tipo II",
                            "field4": "pz. 10",
                            "description": "mascherine chirurgiche sicura protection tipo II pz. 10",
                            "grammage": 0,
                            "price": "3.90",
                            "price_label": "€ 3,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 51.643192488262905,
                                "left": 0.0,
                                "width": 21.52370892018779,
                                "height": 15.211267605633804
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/mascherine_1599054951.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_go9DF8w_TtH7nrU.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "132303",
                            "field1": "dentifricio",
                            "field2": "colgate",
                            "field3": "ml. 75",
                            "field4": "vari tipi",
                            "description": "dentifricio colgate ml. 75 vari tipi",
                            "grammage": 75,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Orale",
                            "blueprint": {
                                "top": 66.94835680751174,
                                "left": 0.0,
                                "width": 33.34162754303599,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Colgate_baking_soda_dentifricio_75_ml.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_esxOJMQ_h1uLLJl.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "141028",
                            "field1": "fazzoletti",
                            "field2": "tempo",
                            "field3": "pz. 10",
                            "field4": "",
                            "description": "fazzoletti tempo pz. 10",
                            "grammage": 0,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Persona",
                            "subcategory": "Viso",
                            "blueprint": {
                                "top": 82.72300469483568,
                                "left": 0.0,
                                "width": 33.34162754303599,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Tempo_classici_10_pacchetti_1451929340_1548759364_1568797961.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_Jvp0mBh_hvhZ525.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "216752",
                            "field1": "carta igienica",
                            "field2": "corona",
                            "field3": "grande & bella",
                            "field4": "4 rotoli",
                            "description": "carta igienica corona grande & bella 4 rotoli",
                            "grammage": 0,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 66.94835680751174,
                                "left": 34.331298904538336,
                                "width": 31.204616588419405,
                                "height": 31.361502347417844
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Corona_Carta_Igienica_4rotoli_3_veli_1583935648_1594637696.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_uitTKfB_y3ifzWK.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 15,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_15_81UYvJX.jpg",
                    "products": [
                        {
                            "item_id": "206896",
                            "field1": "detersivo liquido lavatrice",
                            "field2": "dash",
                            "field3": "vari tipi",
                            "field4": "17 lavaggi",
                            "description": "detersivo liquido lavatrice dash vari tipi 17 lavaggi",
                            "grammage": null,
                            "price": "2.99",
                            "price_label": "€ 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 7.562060637247176,
                                "left": 0.0,
                                "width": 44.34084507042253,
                                "height": 26.6599162841911
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/principale_8001090797933_1570026998_1575628423_1582737271_tWe4T33.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/principale_8001090797810_1570026998_1575628424_1582737271_3KGwjWY.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_wNfWlE8_36LNEU2.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "play",
                                    "title": "Dash - Come dosare",
                                    "data": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/video/Dash-Come-dosare-il-detersivo-liquido.mp4"
                                }
                            ]
                        },
                        {
                            "item_id": "205662",
                            "field1": "detergente",
                            "field2": "mastro lindo",
                            "field3": "varie superfici",
                            "field4": "liquido ml. 950/ spray ml. 500",
                            "description": "detergente mastro lindo varie superfici liquido ml. 950/ spray ml. 500",
                            "grammage": null,
                            "price": "1.00",
                            "price_label": "€ 1,00",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Pavimenti",
                            "blueprint": {
                                "top": 7.374267210017129,
                                "left": 44.37237871674491,
                                "width": 55.62762128325508,
                                "height": 27.035503138651194
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Mastrolindo_limone_ml_950_1455622303_1499071704_1537808833_157951024_DyWRTkH.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/mastrolindo_bagno_1513958106_1514970614_1530801719_1579515465_1581333664.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/mastro_lindo_spray_1561106264_1581334545.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_HSLr6IP_Cw9HRYe.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "189348",
                            "field1": "ammorbidente concentrato liquido",
                            "field2": "lenor",
                            "field3": "ml. 650",
                            "field4": "varie profumazioni",
                            "description": "ammorbidente concentrato liquido lenor ml. 650 varie profumazioni",
                            "grammage": 650,
                            "price": "1.25",
                            "price_label": "€ 1,25",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 34.460093896713616,
                                "left": 0.0,
                                "width": 33.66737089201877,
                                "height": 16.71361502347418
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/4015400917410_lenor_oro_e_fiori_26_lavaggi_1559667379_1567789121.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/8001090026798_lenor_ammorbidente_concentrato_lavanda_1559667895_1567789121.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_exzQ8GA_OMSvj9Y.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "131012",
                            "field1": "detersivo lavatrice in polvere",
                            "field2": "general",
                            "field3": "fustone",
                            "field4": "90 misurini",
                            "description": "detersivo lavatrice in polvere general fustone 90 misurini",
                            "grammage": 0,
                            "price": "6.99",
                            "price_label": "€ 6,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 51.17370892018779,
                                "left": 0.0,
                                "width": 33.66737089201877,
                                "height": 15.492957746478874
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/General_detersivo_90_misurini.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_qtRmgGF_DezDfdV.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "140210",
                            "field1": "sacchetto spazzy antiforo",
                            "field2": "domopak",
                            "field3": "cm. 70 x 120 - pz. 15",
                            "field4": "vari tipi",
                            "description": "sacchetto spazzy antiforo domopak cm. 70 x 120 - pz. 15 vari tipi",
                            "grammage": 0,
                            "price": "1.09",
                            "price_label": "€ 1,09",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 67.13615023474179,
                                "left": 0.0,
                                "width": 33.66737089201877,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/domopack-spazzy-antiforo_1512036517.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_KvevwFs_4lps470.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "211952",
                            "field1": "spray",
                            "field2": "vetril",
                            "field3": "vari tipi",
                            "field4": "ml. 650",
                            "description": "spray vetril vari tipi ml. 650",
                            "grammage": 650,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 82.91079812206573,
                                "left": 0.0,
                                "width": 33.66737089201877,
                                "height": 15.399061032863848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/vetril_ammoniaca_spray_1588688311.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/VETRIL_Natural_650_ml_1463653391_1588688311.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_tWbKuQN_5gA3e8v.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "178171",
                            "field1": "spugna abrasiva con impugnatura",
                            "field2": "arix",
                            "field3": "pz. 3",
                            "field4": "",
                            "description": "spugna abrasiva con impugnatura arix pz. 3",
                            "grammage": 0,
                            "price": "0.69",
                            "price_label": "€ 0,69",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 34.647887323943664,
                                "left": 33.66737089201877,
                                "width": 32.53247261345853,
                                "height": 16.43192488262911
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/arix_splendelli_x3_1553273061.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_zax3sAr_hlhCy2Y.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "195546",
                            "field1": "brillante spray",
                            "field2": "bref",
                            "field3": "vari tipi",
                            "field4": "ml. 650/750",
                            "description": "brillante spray bref vari tipi ml. 650/750",
                            "grammage": 750,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 34.55399061032864,
                                "left": 66.40524256651017,
                                "width": 33.594757433489825,
                                "height": 16.43192488262911
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/BREF_Brillante_Bagno_Trigger_750_ml_1561997248_1571818919.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/BREF_Brillante_Multiuso_Trigger_750_ml_1561997302_1571818919.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_6v5iYpI_hYtJm7L.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "140168",
                            "field1": "smacchia facile",
                            "field2": "omino bianco",
                            "field3": "ml. 500 ",
                            "field4": "",
                            "description": "smacchia facile omino bianco ml. 500 ",
                            "grammage": 500,
                            "price": "1.49",
                            "price_label": "€ 1,49",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Bucato",
                            "blueprint": {
                                "top": 50.985915492957744,
                                "left": 33.872769953051645,
                                "width": 32.26690140845071,
                                "height": 15.86854460093897
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/5415_omino_bianco_100_smacchia_facile_1513616678.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_fZ0JANg_rUGR0fS.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "201956",
                            "field1": "panno spugna",
                            "field2": "logex",
                            "field3": "pz. 3",
                            "field4": "",
                            "description": "panno spugna logex pz. 3",
                            "grammage": null,
                            "price": "0.89",
                            "price_label": "€ 0,89",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 51.17370892018779,
                                "left": 66.27245696400625,
                                "width": 33.72754303599374,
                                "height": 15.492957746478877
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/8003350501052_logex_3_panni_spugna_1559724343_1576661190.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_O6RrJ1z_HEPkETU.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "173205",
                            "field1": "detergente piatti concentrato",
                            "field2": "winni’s",
                            "field3": "ml. 500",
                            "field4": "aloe/lime e fiori di mela",
                            "description": "detergente piatti concentrato winni’s ml. 500 aloe/lime e fiori di mela",
                            "grammage": 500,
                            "price": "0.99",
                            "price_label": "€ 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "aloe",
                                "lime e fiori di mela"
                            ],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Extra",
                            "blueprint": {
                                "top": 66.85446009389672,
                                "left": 33.872769953051645,
                                "width": 15.668701095461659,
                                "height": 31.455399061032864
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/WINNIS_DETERGENTE_PIATTI_LIME_CONCENTRATO_ML.500_1543659814.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_kfrhgdD_6YmlO2I.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "173203",
                            "field1": "detergente bagno",
                            "field2": "winni’s",
                            "field3": "ml. 500",
                            "field4": "",
                            "description": "detergente bagno winni’s ml. 500",
                            "grammage": 500,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Superfici",
                            "blueprint": {
                                "top": 66.7605633802817,
                                "left": 49.93982785602503,
                                "width": 11.685133020344288,
                                "height": 31.455399061032864
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Winnis_Bagno_Trigger_500_ml_1498237841.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_bm2JAy8_EaBI5tw.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        },
                        {
                            "item_id": "195547",
                            "field1": "pavimenti e superfici lavabili",
                            "field2": "winni's ",
                            "field3": "lt. 1",
                            "field4": "",
                            "description": "pavimenti e superfici lavabili winni's  lt. 1",
                            "grammage": null,
                            "price": "1.79",
                            "price_label": "€ 1,79",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene Casa",
                            "subcategory": "Pavimenti",
                            "blueprint": {
                                "top": 66.7605633802817,
                                "left": 61.890532081377145,
                                "width": 11.685133020344288,
                                "height": 31.455399061032864
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/Winnis-Pavimenti-e-Superfici-1000-ml-40-lav_1543657763_1571329792_1571818955.jpg",
                                    "cropped": false
                                },
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_vsoc8Ib_piNh4IB.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 16,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/page_16_dTbR9Jd.jpg",
                    "products": [
                        {
                            "item_id": "cstm89588675",
                            "field1": "I Colori del Buongioro",
                            "field2": "Ricevi 1 bollino ogni €10 di spesa",
                            "field3": "Dal 7 settembre al 14 novembre",
                            "field4": "",
                            "description": "I Colori del Buongioro Ricevi 1 bollino ogni €10 di spesa Dal 7 settembre al 14 novembre",
                            "grammage": null,
                            "price": "0.00",
                            "price_label": "",
                            "equivalence": null,
                            "quantity_step": null,
                            "grocery_label": "",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": null,
                            "max_purchasable_pieces": null,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": true,
                            "underpriced_product": false,
                            "category": "No Food",
                            "subcategory": "Home",
                            "blueprint": {
                                "top": 0.0,
                                "left": 0.0,
                                "width": 100.0,
                                "height": 51.643192488262905
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/products/cropped_image_yNXKKjp_38N5Sqn.png",
                                    "cropped": true
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "title": null,
                                    "data": ""
                                }
                            ]
                        }
                    ]
                },
                {
                    "number": 17,
                    "image_file": "https://interattivo.s3.amazonaws.com/mu5kxW23CP/pages/Endpage_Vivo_khNSsn4.png",
                    "products": []
                }
            ]
        }
    }

}

const lefletSwitch = () => {
    return leaflets.vivo;
}

export const serverResponse = lefletSwitch();
